import './NewCustomer.css';
import {useEffect, useState} from 'react';
import { useSearchParams,useParams } from "react-router-dom";
import Logo from '../refs/CornerstoneColor.jpg';
import { ImCheckboxUnchecked, ImCheckboxChecked  } from "react-icons/im";
import { FaStar, FaCheck, FaDotCircle  } from "react-icons/fa";
import { HiBadgeCheck } from "react-icons/hi";
import LoadingSpinner from '../Components/LoadingSpinner';
import { IoWarning } from "react-icons/io5";

import newCustomerDataService from '../Services/NewCustomerService';


// SERVER INTERACTION - - - - - - -

const submitCustomerRequest = async (customerObject,setFormSubmissionValid) => {
    newCustomerDataService.submitCustomerRecord(customerObject).then(response => {
        if(response.status > 199 && response.status < 300) setFormSubmissionValid(true);
        else setFormSubmissionValid(false);
    })
};

const submitCustomerUpdateRequest = async(customerObject,setFormSubmissionValid) => {
    newCustomerDataService.updateCustomerRecord(customerObject).then(response => {
        if(response.status > 199 && response.status < 300) setFormSubmissionValid(true);
        else setFormSubmissionValid(false);
    })
};

const getBlankW9 = () => {
    newCustomerDataService.getW9()
};

const sendW9 = async (w9, filename, setW9Id, setW9Error) => {
    newCustomerDataService.submitW9(w9,filename)
    .then(response =>{
        setW9Id(response.data.id);
    }).catch( e=> {
        setW9Error(e.toString());
    });
};

const sendInternationalWire = async (intWire, filename, setIntWireId, setIntWireError) => {
    newCustomerDataService.submitIntWire(intWire,filename)
    .then(response =>{
        setIntWireId(response.data.id);
    }).catch( e=> {
        setIntWireError(e.toString());
    });
};

const sendVoidedCheck = async (voidCheck, filename, setVoidedCheckFileId, setVoidedCheckError) => {
    newCustomerDataService.submitVoidedCheck(voidCheck,filename)
    .then(response =>{
        setVoidedCheckFileId(response.data.id);
    }).catch( e=> {
        setVoidedCheckError(e.toString());
    });
};

const sendTaxCert = async (taxCert, filename, setTaxCertId, setTaxCertError) => {
    newCustomerDataService.submitTaxExemption(taxCert,filename)
    .then(response =>{
        setTaxCertId(response.data.id);
    }).catch( e=> {
        setTaxCertError(e.toString());
    });
};

const sendCreditReferenceSheet = async (creditReferenceSheet, filename, setCreditReferenceSheetId, setCreditReferenceSheetError) => {
    newCustomerDataService.submitCreditReferencesSheet(creditReferenceSheet,filename)
    .then(response =>{
        setCreditReferenceSheetId(response.data.id);
    }).catch( e=> {
        setCreditReferenceSheetError(e.toString());
    });
};

const sendTradeReferenceSheet = async (tradeReferenceSheet, filename, setTradeReferenceSheetId, setTradeReferenceSheetError) => {
    newCustomerDataService.submitTradeReferencesSheet(tradeReferenceSheet,filename)
    .then(response =>{
        setTradeReferenceSheetId(response.data.id);
    }).catch( e=> {
        setTradeReferenceSheetError(e.toString());
    });
};

const grabRejectionRecord = async (sessionId,rejectionId,setRejectionRecord) => {
    newCustomerDataService.getRejectionRecord(sessionId, rejectionId).then(res => {if(res.data)setRejectionRecord(res.data)});
};


// HELPER FUNCTIONS - - - - - - - - - - -

const getDate = (seperator='.') => {
    var today = new Date();
    var dd = String(today.getDate()).padStart(2, '0');
    var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
    var yyyy = today.getFullYear();
    
    today = mm + seperator + dd + seperator + yyyy;
    return today;
};

const SignatureInput = ({title,setTo,complete=false ,width=0}) => {
    const [displayWidth, setDisplayWidth ] = useState('auto');

    const inputCssProps = {
        '--inputWidth': `${displayWidth}`
    };

    useEffect(() => {
        if(width > 0) setDisplayWidth(`${width}px`)
        else setDisplayWidth('auto')
    },[])

    return(
        <>
        <link rel="preconnect" href="https://fonts.googleapis.com"/>
        <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin='true'/>
        <link href="https://fonts.googleapis.com/css2?family=Whisper&display=swap" rel="stylesheet"/>

        <div className='External-Form-Input' style={inputCssProps}>
            {   !complete &&
                <FaStar className='External-Form-Input-Required' />
            }
            {   complete &&
                <FaCheck className='External-Form-Input-Complete' />
            }
            
            <div className='External-Form-Input-Title'>
                {title}
            </div>
            <input type="text" className='External-Form-Signature-Box' onChange={(e) => setTo(e.target.value)} />
        </div>
        </>
    )
};

const TextInput = ({title,setTo, complete=false ,width=0,charCount=0,required=false,active=true, under=false, initializedValue=null, disabled=false}) => {
    const [displayWidth, setDisplayWidth ] = useState('auto');

    const inputCssProps = {
        '--inputWidth': `${displayWidth}`
    };

    useEffect(() => {
        if(width>0){
            setDisplayWidth(`${width}px`)
        }
        else{
            if(charCount > 0){
                setDisplayWidth(`${charCount*17}px`);
            }
            else{
                setDisplayWidth('auto')
            }
        }
    },[])

    if(!under){
        return(
            <div className='External-Form-Input' style={inputCssProps}>
                {   active && required && !complete &&
                <FaStar className='External-Form-Input-Required' />
                }
                {   active && !required && !complete &&
                <FaStar className='External-Form-Input-Not-Required' />
                }
                {   active && complete &&
                <FaCheck className='External-Form-Input-Complete' />
                }
                <div className='External-Form-Input-Title'>
                    {title}
                </div>
                {   charCount > 0 &&
                    <input type="text" disabled={disabled} placeholder={initializedValue} inputMode='numeric' maxLength={charCount} className='External-Form-Input-Contrained' onChange={(e) => setTo(e.target.value)}/>
                }
                {   charCount < 1 &&
                    <input type="text" disabled={disabled} placeholder={initializedValue} className='External-Form-Input-Box' onChange={(e) => setTo(e.target.value)} />
                }
                
            </div>
        )
    }
    else{
        return(
            <div className='External-Form-Input-Under' style={inputCssProps}>
                {   active && required && !complete &&
                <FaStar className='External-Form-Input-Required' />
                }
                {   active && !required && !complete &&
                <FaStar className='External-Form-Input-Not-Required' />
                }
                {   active && complete &&
                <FaCheck className='External-Form-Input-Complete' />
                }

                {   charCount > 0 &&
                    <input type="text" inputMode='numeric' placeholder={initializedValue} maxLength={charCount} className='External-Form-Input-Contrained' onChange={(e) => setTo(e.target.value)}/>
                }
                {   charCount < 1 &&
                    <input type="text" className='External-Form-Input-Box' placeholder={initializedValue} onChange={(e) => setTo(e.target.value)} />
                }

                <div className='External-Form-Input-Title-Under'>
                    {title}
                </div>
                
            </div>
        )
    }

};

const DropDownSelection = ({title, options, setTo, complete=false, width, active, required, initializedValue}) => {
    const inputCssProps = {
        '--inputWidth': `${width}`
    };

    const selectOption = (value) => {
         setTo(value);
    };

    return(
        <div className='External-Form-Input' style={inputCssProps}>
        {   active && required && !complete &&
        <FaStar className='External-Form-Input-Required' />
        }
        {   active && required && complete &&
        <FaCheck className='External-Form-Input-Complete' />
        }
        <div className='External-Form-Input-Title'>
            {title}
        </div>
        {   !initializedValue &&
        <select className='External-Form-Dropdown'onChange={(e) => selectOption(e.target.value)}>
            <option value={false}> </option>
            {   options.map((option, key) => (
                <option className='External-Form-Dropdown-Selection' key={key} value={option}>{option}</option>
            ))
            }
        </select>
        }
        {   initializedValue &&
        <select className='External-Form-Dropdown' onChange={(e) => selectOption(e.target.value)}>
            <option value={true}>{initializedValue}</option>
            {   options.map((option, key) => (
                <option className='External-Form-Dropdown-Selection' key={key} value={option}>{option}</option>
            ))
            }
        </select>
        }

        
    </div>
    )
};

const AccountSelector = ({title, selected, setTo}) => {
    return(
        <div className='External-Vendor-Type-Selection-Group'>
            {   !selected &&
                <ImCheckboxUnchecked className='External-Vendor-Type-Selection' onClick={() => setTo(true)}/>
            }
            {   selected &&
                <ImCheckboxChecked className='External-Vendor-Type-Selection' onClick={() => setTo(false)}/>
            }
            <div className='External-Vendor-Type-Selection-Text'>
                {title}
            </div>
        </div>
    )
};

const checkEmail = (email) => {
    let valid = true;
    try{
        let re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    
        if(re.test(email)){
            // Valid Email
        }
        else{
            valid = false;
        }
    }
    catch{
        valid = false;
    }

    return valid;
};

// DISPLAY SECTIONS - - - - - - - - - -
// HEADER
const FormHeader = ({formEmail}) => {
    return(
        <div className='External-Form-Header'>
            <img src={Logo} className='External-Form-Logo' alt='Cornerstone Logo'/>

            <div className='External-Form-Contact'>
                <div className='External-Form-Contact-Content'>
                    2511 Midpark Road, Montgomery, AL 36109
                </div>
                <div className='External-Form-Contact-Content'>
                    (334)-281-8440
                </div>
            </div>
            <div className='External-Form-Email-Support'>
                {formEmail}
            </div>
            <div className='External-Vendor-Title'>
                    New Customer Form
            </div>
        </div>
    )
};

// CUSTOMER INFORMATION SECTION
const CustomerInformation = ({customerInformationActive,setFedEinSSn,fedEinSSn,fedEinSSnComplete,setDunsNo,dunsNo,dunsNoComplete,setWebsite,
    website,websiteComplete,setLegalName,legalName,legalNameComplete,setTradeNameDBA,tradeNameDBA,tradeNameDBAComplete,setStreet,street,setStreet2,
    street2,streetComplete,setCity,city,cityComplete,setState,state,stateComplete,setZip,zip,zipComplete,setCountry,country,setShippingStreet,
    shippingStreet,shippingStreetComplete,setShippingStreet2,shippingStreet2,setShippingCity,shippingCity,shippingCityComplete,setShippingState,
    shippingState,shippingStateComplete,setShippingZip,shippingZip,shippingZipComplete,setShippingCountry,shippingCountry,taxExemptOptions,setTaxExemptCert,
    taxExemptCert,taxExemptCertComplete,paymentOptions,setPaymentMethod,paymentMethod,paymentMethodComplete,businessTypeOptions,setBusinessTypeSelection,
    businessTypeSelection,businessTypeSelectionComplete,setStateOfInc,stateOfInc,stateOfIncComplete,poRequired,setPoRequired,poRequiredComplete,poOptions,
    customerClassOptions,setCustomerClassSelection,customerClassSelection,customerClassSelectionComplete}) => {

    const [ shippingSameAsBilling, setShippingSameAsBilling ] = useState(false);

    useEffect(() => {
        if(street && street === shippingStreet){
            setShippingSameAsBilling(true);
        };
    },[]);

    useEffect(() => {
        if(shippingSameAsBilling){
            setShippingStreet(street);
            setShippingStreet2(street2);
            setShippingCity(city);
            setShippingState(state);
            setShippingZip(zip);
            setShippingCountry(country);
        }
        else{
            setShippingStreet('');
            setShippingStreet2('');
            setShippingCity('');
            setShippingState('');
            setShippingZip('');
            setShippingCountry(''); 
        };
    },[shippingSameAsBilling,street,street2,city,state,zip,country]);

    return( 
        <div className='External-Information-Section'>
            {   customerInformationActive &&
                <>
                <div className='External-Customer-Title'>
                    Please enter all required company information to continue.
                </div>
                </>
            }

            <div className='External-Form-Spacer'/>

            <div className='External-Form-Input-Title-Row'>Company Information:</div>

            <TextInput title={'Federal EIN/SSN:'} setTo={setFedEinSSn} complete={fedEinSSnComplete} charCount={9} required={true} active={customerInformationActive} initializedValue={fedEinSSn}/>
            <TextInput title={'Duns No.:'} setTo={setDunsNo} complete={dunsNoComplete} charCount={9} required={false} active={customerInformationActive} initializedValue={dunsNo}/>
            <TextInput title={'Website:'} setTo={setWebsite} complete={websiteComplete} width={340} required={false} active={customerInformationActive} initializedValue={website}/>
            <TextInput title={'Legal Name:'} setTo={setLegalName} complete={legalNameComplete} width={340} required={true} active={customerInformationActive} initializedValue={legalName}/>
            <TextInput title={'Trade Name/DBA:'} setTo={setTradeNameDBA} complete={tradeNameDBAComplete} width={340} required={false} active={customerInformationActive} initializedValue={tradeNameDBA}/>

            <div className='External-Form-Spacer'/>

            <div className='External-Form-Input-Title'>
            Billing Address:
            </div>
            <TextInput title={'Street:'} setTo={setStreet} complete={streetComplete} width={220} required={true} active={customerInformationActive} under={true} initializedValue={street}/>
            <TextInput title={'Street2:'} setTo={setStreet2} width={120} required={false} active={customerInformationActive} under={true} initializedValue={street2}/>
            <TextInput title={'City:'} setTo={setCity} complete={cityComplete} width={140} required={true} active={customerInformationActive} under={true} initializedValue={city}/>
            <TextInput title={'State/Province:'} setTo={setState} complete={stateComplete} charCount={2} width={70} required={true} active={customerInformationActive} under={true} initializedValue={state}/>
            <TextInput title={'Zip:'} setTo={setZip} complete={zipComplete} charCount={6} required={true} active={customerInformationActive} under={true} initializedValue={zip}/>
            <TextInput title={'Country:'} setTo={setCountry} charCount={2} required={false} active={customerInformationActive} under={true} initializedValue={country}/>

            <div className='External-Form-Spacer'/>


            {   !shippingSameAsBilling &&
                <>
                    <div className='External-Form-Input-Title'>Shipping Address:</div>
                    <TextInput title={'Street:'} setTo={setShippingStreet} complete={shippingStreetComplete} width={220} required={true} active={customerInformationActive} under={true} initializedValue={shippingStreet}/>
                    <TextInput title={'Street2:'} setTo={setShippingStreet2} width={120} required={false} active={customerInformationActive} under={true} initializedValue={shippingStreet2}/>
                    <TextInput title={'City:'} setTo={setShippingCity} complete={shippingCityComplete} width={140} required={true} active={customerInformationActive} under={true} initializedValue={shippingCity}/>
                    <TextInput title={'State/Province:'} setTo={setShippingState} complete={shippingStateComplete} charCount={2} width={70} required={true} active={customerInformationActive} under={true} initializedValue={shippingState}/>
                    <TextInput title={'Zip:'} setTo={setShippingZip} complete={shippingZipComplete} charCount={6} required={true} active={customerInformationActive} under={true} initializedValue={shippingZip}/>
                    <TextInput title={'Country:'} setTo={setShippingCountry} charCount={2} required={false} active={customerInformationActive} under={true} initializedValue={shippingCountry}/>
                </>
            }

            <div className='External-Form-Spacer'/>

            {   !shippingSameAsBilling &&
                <button className='External-Form-Shipping-Button' onClick={() => setShippingSameAsBilling(true)}>Mark Shipping Address Same as Billing Address</button>
            }
            {   shippingSameAsBilling &&
                <button className='External-Form-Shipping-Button' onClick={() => setShippingSameAsBilling(false)}>Shipping Address Differs from Billing Address</button>
            }
            
            <div className='External-Form-Spacer'>
            </div>
            <DropDownSelection title={'Tax Exempt:'} setTo={setTaxExemptCert} complete={taxExemptCertComplete} options={taxExemptOptions} width={200} required={true} active={customerInformationActive} initializedValue={taxExemptCert}/>
            <DropDownSelection title={'PO Required:'} setTo={setPoRequired} complete={poRequiredComplete} options={poOptions} width={200} required={true} active={customerInformationActive} initializedValue={poRequired}/>
            <DropDownSelection title={'Payment Method:'} setTo={setPaymentMethod} complete={paymentMethodComplete} options={paymentOptions} width={200} required={true} active={customerInformationActive} initializedValue={paymentMethod}/>
            <DropDownSelection title={'Business Type:'} setTo={setBusinessTypeSelection} complete={businessTypeSelectionComplete} options={businessTypeOptions} width={200} required={true} active={customerInformationActive} initializedValue={businessTypeSelection}/>
            <DropDownSelection title={'Customer Classification:'} setTo={setCustomerClassSelection} complete={customerClassSelectionComplete} options={customerClassOptions} width={200} required={true} active={customerInformationActive} initializedValue={customerClassSelection}/>
            <TextInput title={'State Of Incorporation:'} setTo={setStateOfInc} complete={stateOfIncComplete} width={40} charCount={2} required={true} active={customerInformationActive} initializedValue={stateOfInc}/>
        </div>
    )
};

// PRIMARY & AP INFORMATION SECTION
const PrimaryContactAndAPInformation = ({primaryContactAndApActive,setPrimaryContactFirstName,primaryContactFirstName,setPrimaryContactLastName,primaryContactLastName,
    primaryContactFirstNameComplete,primaryContactLastNameComplete,setPrimaryContactNumber,primaryContactNumber,primaryContactNumberComplete,
    setPrimaryExtension,primaryExtension,setPrimaryTitle,primaryTitle,primaryTitleComplete,setPrimaryContactEmail,
    primaryContactEmail,primaryContactEmailComplete,setContactFirstNameAP,contactFirstNameAP,setContactLastNameAP,contactLastNameAP,contactFirstNameAPComplete,contactLastNameAPComplete,
    titleAP,setTitleAP,titleAPComplete,setPhoneAP,phoneAP,phoneAPComplete,extensionAP,setExtensionAP,setContactEmailAP,contactEmailAP,contactEmailAPComplete,}) => {


    const [ payableSameAsPrimary, setPayableSameAsPrimary ] = useState(false);

    useEffect(() => {
        if((primaryContactFirstName && primaryContactFirstName === contactFirstNameAP) && (primaryContactLastName && primaryContactLastName === contactLastNameAP)){
                setPayableSameAsPrimary(true);
        };
    },[]);

    useEffect(() => {
        if(payableSameAsPrimary){
            setContactFirstNameAP(primaryContactFirstName);
            setContactLastNameAP(primaryContactLastName);
            setTitleAP(primaryTitle);
            setPhoneAP(primaryContactNumber);
            setExtensionAP(primaryExtension);
            setContactEmailAP(primaryContactEmail);
        }
        else{
            setContactFirstNameAP('');
            setContactLastNameAP('');
            setTitleAP('');
            setPhoneAP('');
            setExtensionAP('');
            setContactEmailAP('');
        };
    },[payableSameAsPrimary,primaryContactFirstName,primaryContactLastName,primaryTitle,primaryContactNumber,primaryExtension,primaryContactEmail]);

    return(
        <div className='External-Information-Section'>
            {   primaryContactAndApActive &&
                <>
                <div className='External-Customer-Title'>
                    Please enter all required contact information to continue.
                </div>
                </>
            }
            <div className='External-Form-Spacer'/>

            <div className='External-Form-Input-Title-Row'>Primary Contact:</div>
            <TextInput title={'First Name:'} setTo={setPrimaryContactFirstName} complete={primaryContactFirstNameComplete} width={150} required={true} active={primaryContactAndApActive} initializedValue={primaryContactFirstName}/>
            <TextInput title={'Last Name:'} setTo={setPrimaryContactLastName} complete={primaryContactLastNameComplete} width={150} required={true} active={primaryContactAndApActive} initializedValue={primaryContactLastName}/>
            <TextInput title={'Title:'} setTo={setPrimaryTitle} complete={primaryTitleComplete} width={150} required={true} active={primaryContactAndApActive} initializedValue={primaryTitle}/>
            <TextInput title={'Phone:'} setTo={setPrimaryContactNumber} complete={primaryContactNumberComplete} charCount={10} required={true} active={primaryContactAndApActive} initializedValue={primaryContactNumber}/>
            <TextInput title={'Extension'} setTo={setPrimaryExtension} charCount={6} required={false} active={primaryContactAndApActive}  initializedValue={primaryExtension}/>
            <TextInput title={'Email Address:'} setTo={setPrimaryContactEmail} complete={primaryContactEmailComplete} width={340} required={true} active={primaryContactAndApActive} initializedValue={primaryContactEmail}/>

            <div className='External-Form-Spacer'/>

            {   !payableSameAsPrimary &&
                <button className='External-Form-Shipping-Button' onClick={() => setPayableSameAsPrimary(true)}>Mark Accounts Payable Contact Same as Primary Contact</button>
            }
            {   payableSameAsPrimary &&
                <button className='External-Form-Shipping-Button' onClick={() => setPayableSameAsPrimary(false)}>Accounts Payable Contact Differs from Primary Contact</button>
            }

            {
                !payableSameAsPrimary &&
                <>
                    <div className='External-Form-Input-Title-Row'>Accounts Payable Contact:</div>
                    <TextInput title={'First Name:'} setTo={setContactFirstNameAP} complete={contactFirstNameAPComplete} width={150} required={true} active={primaryContactAndApActive} initializedValue={contactFirstNameAP}/>
                    <TextInput title={'Last Name:'} setTo={setContactLastNameAP} complete={contactLastNameAPComplete} width={150} required={true} active={primaryContactAndApActive} initializedValue={contactLastNameAP}/>
                    <TextInput title={'Title:'} setTo={setTitleAP} complete={titleAPComplete} width={150} required={true} active={primaryContactAndApActive} initializedValue={titleAP}/>
                    <TextInput title={'Phone:'} setTo={setPhoneAP} complete={phoneAPComplete} charCount={10}  required={true} active={primaryContactAndApActive} initializedValue={phoneAP}/>
                    <TextInput title={'Extension'} setTo={setExtensionAP} charCount={6} required={false} active={primaryContactAndApActive}  initializedValue={extensionAP}/>
                    <TextInput title={'Email Address:'} setTo={setContactEmailAP} complete={contactEmailAPComplete} width={340} required={true} active={primaryContactAndApActive} initializedValue={contactEmailAP}/>
                </>
            }
            
            <div className='External-Form-Spacer'/>


            
            <div className='External-Form-Spacer'></div>
        </div>
    )
};

// OWNERS OR AUTHORIZED OFFICERS SECTION
const OwnersOrOfficersInformation = ({ownersOrOfficersInformationActive,setFirstName1,firstName1,setLastName1,lastName1,ownerFirstName1Complete,ownerLastName1Complete,setFirstName2,
    firstName2,setLastName2,lastName2,ownerFirstName2Complete,ownerLastName2Complete,setTitle,title,titleComplete,setPhone,phone,phoneComplete,setExtension,extension,setOwnerStreet
    ,ownerStreet,ownerStreetComplete,setOwnerStreet2,ownerStreet2,setOwnerCity,ownerCity,ownerCityComplete,setOwnerState,ownerState,ownerStateComplete,setOwnerZip,ownerZip,
    ownerZipComplete,setOwnerCountry,ownerCountry,setOwner2Street,owner2Street,owner2StreetComplete,setOwner2Street2,owner2Street2,setOwner2City,owner2City,owner2CityComplete,
    setOwner2State,owner2State,owner2StateComplete,setOwner2Zip,owner2Zip,owner2ZipComplete,setOwner2Country,owner2Country,setEmailAddress,emailAddress,emailAddressComplete,
    setSecondaryOwner,secondaryOwner,setTitle2,title2,title2Complete,setPhone2,phone2,phone2Complete,setExtension2,extension2,
    setEmailAddress2,emailAddress2,emailAddress2Complete
    }) => {

    return(
        <div className='External-Information-Section'>

            {   ownersOrOfficersInformationActive &&
                <>
                <div className='External-Customer-Title'>
                    Please enter all required owners or authorized officers information to continue.
                </div>
                </>
            }
            <div className='External-Form-Spacer'/>

            <div className='External-Form-Input-Title-Row'>Owners or Authorized Officers:</div>

            <div className='External-Customer-Contact-Group'> 
            <TextInput title={'First Name:'} setTo={setFirstName1} complete={ownerFirstName1Complete} width={200} required={true} active={ownersOrOfficersInformationActive} initializedValue={firstName1}/>
            <TextInput title={'Last Name:'} setTo={setLastName1} complete={ownerLastName1Complete} width={200} required={true} active={ownersOrOfficersInformationActive} initializedValue={lastName1}/>
            <TextInput title={'Title:'} setTo={setTitle} complete={titleComplete} width={150} required={true} active={ownersOrOfficersInformationActive} initializedValue={title}/>
            <TextInput title={'Email Address:'} setTo={setEmailAddress} complete={emailAddressComplete} width={300} required={true} active={ownersOrOfficersInformationActive} initializedValue={emailAddress}/>
            <TextInput title={'Phone:'} setTo={setPhone} complete={phoneComplete} charCount={10} required={true} active={ownersOrOfficersInformationActive} initializedValue={phone}/>
            <TextInput title={'Extension'} setTo={setExtension} charCount={6} required={false} active={ownersOrOfficersInformationActive}  initializedValue={extension}/>
            
            <div className='External-Form-Spacer'/>

            <div className='External-Form-Input-Title'>Address:</div>
            <TextInput title={'Street:'} setTo={setOwnerStreet} complete={ownerStreetComplete} width={220} required={true} active={ownersOrOfficersInformationActive} under={true} initializedValue={ownerStreet}/>
            <TextInput title={'Street2:'} setTo={setOwnerStreet2} width={120} required={false} active={ownersOrOfficersInformationActive} under={true} initializedValue={ownerStreet2}/>
            <TextInput title={'City:'} setTo={setOwnerCity} complete={ownerCityComplete} width={140} required={true} active={ownersOrOfficersInformationActive} under={true} initializedValue={ownerCity}/>
            <TextInput title={'State/Province:'} setTo={setOwnerState} complete={ownerStateComplete} charCount={2} width={40} required={true} active={ownersOrOfficersInformationActive} under={true} initializedValue={ownerState}/>
            <TextInput title={'Zip:'} setTo={setOwnerZip} complete={ownerZipComplete} charCount={6} required={true} active={ownersOrOfficersInformationActive} under={true} initializedValue={ownerZip}/>
            <TextInput title={'Country:'} setTo={setOwnerCountry} charCount={2} required={false} active={ownersOrOfficersInformationActive} under={true} initializedValue={ownerCountry}/>

            </div>
            {   !secondaryOwner && 
                <button onClick={() => setSecondaryOwner(true)} className='External-Customer-Contact-Button Button-Add'>Add Secondary Authorized Officer</button>
            }
            {   secondaryOwner && 
                <button onClick={() => setSecondaryOwner(false)} className='External-Customer-Contact-Button Button-Remove'>Remove Secondary Authorized Officer</button>
            }
            { secondaryOwner && 
            <div className='External-Customer-Contact-Group'>
                <TextInput title={'First Name:'} setTo={setFirstName2} complete={ownerFirstName2Complete} width={200} required={true} active={ownersOrOfficersInformationActive} initializedValue={firstName2}/>
                <TextInput title={'Last Name:'} setTo={setLastName2} complete={ownerLastName2Complete} width={200} required={true} active={ownersOrOfficersInformationActive} initializedValue={lastName2}/>
                <TextInput title={'Title:'} setTo={setTitle2} complete={title2Complete} width={150} required={true} active={ownersOrOfficersInformationActive} initializedValue={title2}/>
                <TextInput title={'Email Address:'} setTo={setEmailAddress2} complete={emailAddress2Complete} width={300} required={true} active={ownersOrOfficersInformationActive} initializedValue={emailAddress2}/>
                <TextInput title={'Phone:'} setTo={setPhone2} complete={phone2Complete} charCount={10} required={true} active={ownersOrOfficersInformationActive} initializedValue={phone2}/>
                <TextInput title={'Extension'} setTo={setExtension2} charCount={6} required={false} active={ownersOrOfficersInformationActive}  initializedValue={extension2}/>
            
                <div className='External-Form-Spacer'/>

                <div className='External-Form-Input-Title'>Address:</div>
                <TextInput title={'Street:'} setTo={setOwner2Street} complete={owner2StreetComplete} width={220} required={true} active={ownersOrOfficersInformationActive} under={true} initializedValue={owner2Street}/>
                <TextInput title={'Street2:'} setTo={setOwner2Street2} width={120} required={false} active={ownersOrOfficersInformationActive} under={true} initializedValue={owner2Street2}/>
                <TextInput title={'City:'} setTo={setOwner2City} complete={owner2CityComplete} width={140} required={true} active={ownersOrOfficersInformationActive} under={true} initializedValue={owner2City}/>
                <TextInput title={'State/Province:'} setTo={setOwner2State} complete={owner2StateComplete} charCount={2} width={40} required={true} active={ownersOrOfficersInformationActive} under={true} initializedValue={owner2State}/>
                <TextInput title={'Zip:'} setTo={setOwner2Zip} complete={owner2ZipComplete} charCount={6} required={true} active={ownersOrOfficersInformationActive} under={true} initializedValue={owner2Zip}/>
                <TextInput title={'Country:'} setTo={setOwner2Country} charCount={2} required={false} active={ownersOrOfficersInformationActive} under={true} initializedValue={owner2Country}/>
            </div>
            }
        </div>
    )
};

// TRADE REFERENCES SECTION
const TradeReferencesInformation = ({setTradeReferencesFile,tradeReferencesInformationActive,setCompanyName,companyName,companyNameComplete,setContactFirstName,contactFirstName,
    setContactLastName,contactLastName,contactTradeFirstNameComplete,contactTradeLastNameComplete,setTradeTitle,tradeTitle,tradeTitleComplete,setTradeEmail,tradeEmail,tradeEmailComplete,
    setTradePhone,tradePhone,tradePhoneComplete,setTradeExtension,tradeExtension,setTradeStreet,tradeStreet,tradeStreetComplete,setTradeStreet2,tradeStreet2,
    setTradeCity,tradeCity,tradeCityComplete,setTradeState,tradeState,tradeStateComplete,setTradeZip,tradeZip,tradeZipComplete,setTradeCountry,tradeCountry,
    tradeCountryComplete,setSecondaryReference,secondaryReference,setCompanyName2,companyName2,companyName2Complete,setContactFirstName2,contactFirstName2,
    setContactLastName2,contactLastName2,contactTradeFirstName2Complete,contactTradeLastName2Complete,setTradeTitle2,tradeTitle2,tradeTitle2Complete,setTradeEmail2,tradeEmail2,tradeEmail2Complete,
    setTradePhone2,tradePhone2,tradePhone2Complete,setTradeExtension2,tradeExtension2,setTrade2Street,trade2Street,trade2StreetComplete,setTrade2Street2,
    trade2Street2,setTrade2City,trade2City,trade2CityComplete,setTrade2State,trade2State,trade2StateComplete,setTrade2Zip,trade2Zip,
    trade2ZipComplete,setTrade2Country,trade2Country,trade2CountryComplete,setThirdReference,thirdReference,setCompanyName3,companyName3,companyName3Complete,
    setContactFirstName3,contactFirstName3,setContactLastName3,contactLastName3,contactTradeFirstName3Complete,contactTradeLastName3Complete,setTradeTitle3,tradeTitle3,tradeTitle3Complete,
    setTradeEmail3,tradeEmail3,tradeEmail3Complete,setTradePhone3,tradePhone3,tradePhone3Complete,setTradeExtension3,tradeExtension3,setTrade3Street,trade3Street,
    trade3StreetComplete,setTrade3Street2,trade3Street2,setTrade3City,trade3City,trade3CityComplete,setTrade3State,trade3State,trade3StateComplete,setTrade3Zip,
    trade3Zip,trade3ZipComplete,setTrade3Country,trade3Country,trade3CountryComplete
}) => {

    const [firstRequired, setFirstRequired] = useState(false);

    useEffect( () => {
        if(companyName && companyName.length > 2) setFirstRequired(true);
        else setFirstRequired(false);
    }, [companyName]);

    return(
        <div className='External-Information-Section'>

            <div className='External-Form-Spacer'/>

            <div className='External-Form-Input-Title-Row'>Trade References:</div>

            <div className='External-Trade-Group'>  
                <TextInput title={'Company Name:'} setTo={setCompanyName} complete={companyNameComplete} width={340} required={firstRequired} active={tradeReferencesInformationActive} initializedValue={companyName}/>
                <TextInput title={'Contact First Name:'} setTo={setContactFirstName} complete={contactTradeFirstNameComplete} width={170} required={firstRequired} active={tradeReferencesInformationActive} initializedValue={contactFirstName}/>
                <TextInput title={'Contact Last Name:'} setTo={setContactLastName} complete={contactTradeLastNameComplete} width={170} required={firstRequired} active={tradeReferencesInformationActive} initializedValue={contactLastName}/>
                <TextInput title={'Title:'} setTo={setTradeTitle} complete={tradeTitleComplete} width={170} required={firstRequired} active={tradeReferencesInformationActive} initializedValue={tradeTitle}/>
                <TextInput title={'Email Address:'} setTo={setTradeEmail} complete={tradeEmailComplete} width={340} required={firstRequired} active={tradeReferencesInformationActive} initializedValue={tradeEmail}/>
                <TextInput title={'Phone:'} setTo={setTradePhone} complete={tradePhoneComplete} charCount={10} required={firstRequired} active={tradeReferencesInformationActive} initializedValue={tradePhone}/>
                <TextInput title={'Extension:'} setTo={setTradeExtension}  charCount={6} required={false} active={tradeReferencesInformationActive} initializedValue={tradeExtension}/>
                
                <div className='External-Form-Spacer'/>

                <div className='External-Form-Input-Title'>Contact Address:</div>
                <TextInput title={'Street:'} setTo={setTradeStreet}complete={tradeStreetComplete} width={220} required={firstRequired} active={tradeReferencesInformationActive} under={true} initializedValue={tradeStreet}/>
                <TextInput title={'Street2:'} setTo={setTradeStreet2} width={120} required={false} active={tradeReferencesInformationActive} under={firstRequired} initializedValue={tradeStreet2}/>
                <TextInput title={'City:'} setTo={setTradeCity} complete={tradeCityComplete} width={140} required={firstRequired} active={tradeReferencesInformationActive} under={true} initializedValue={tradeCity}/>
                <TextInput title={'State/Province:'} setTo={setTradeState} complete={tradeStateComplete} charCount={2} width={40} required={firstRequired} active={tradeReferencesInformationActive} under={true} initializedValue={tradeState}/>
                <TextInput title={'Zip:'} setTo={setTradeZip} complete={tradeZipComplete} charCount={6} required={firstRequired} active={tradeReferencesInformationActive} under={true} initializedValue={tradeZip}/>
                <TextInput title={'Country:'} setTo={setTradeCountry} complete={tradeCountryComplete} charCount={2} required={false} active={tradeReferencesInformationActive} under={true} initializedValue={tradeCountry}/>
            </div>

            <div className='External-Form-Spacer'/>

            {   !secondaryReference && 
                <button onClick={() => setSecondaryReference(true)} className='External-Customer-Trade-Reference-Button Button-Add'>Add Second Reference</button>
            }
            {   secondaryReference && 
                <button onClick={() => setSecondaryReference(false)} className='External-Customer-Trade-Reference-Button Button-Remove'>Remove Second Reference</button>
            }

            { secondaryReference && 
            <div className='External-Trade-Group'> 
                <TextInput title={'Company Name:'} setTo={setCompanyName2} complete={companyName2Complete} width={340} required={true} active={tradeReferencesInformationActive} initializedValue={companyName2}/>
                <TextInput title={'Contact First Name:'} setTo={setContactFirstName2} complete={contactTradeFirstName2Complete} width={170} required={true} active={tradeReferencesInformationActive} initializedValue={contactFirstName2}/>
                <TextInput title={'Contact Last Name:'} setTo={setContactLastName2} complete={contactTradeLastName2Complete} width={170} required={true} active={tradeReferencesInformationActive} initializedValue={contactLastName2}/>
                <TextInput title={'Title:'} setTo={setTradeTitle2} complete={tradeTitle2Complete} width={170} required={true} active={tradeReferencesInformationActive} initializedValue={tradeTitle2}/>
                <TextInput title={'Email Address:'} setTo={setTradeEmail2} complete={tradeEmail2Complete} width={280} required={true} active={tradeReferencesInformationActive} initializedValue={tradeEmail2}/>
                <TextInput title={'Phone:'} setTo={setTradePhone2} complete={tradePhone2Complete} charCount={10} required={true} active={tradeReferencesInformationActive} initializedValue={tradePhone2}/>
                <TextInput title={'Extension:'} setTo={setTradeExtension2}  charCount={6} required={false} active={tradeReferencesInformationActive} initializedValue={tradeExtension2}/>
                
                <div className='External-Form-Spacer'/>

                <div className='External-Form-Input-Title'>Contact Address:</div>
                <TextInput title={'Street:'} setTo={setTrade2Street}complete={trade2StreetComplete} width={220} required={true} active={tradeReferencesInformationActive} under={true} initializedValue={trade2Street}/>
                <TextInput title={'Street2:'} setTo={setTrade2Street2} width={120} required={false} active={tradeReferencesInformationActive} under={true} initializedValue={trade2Street2}/>
                <TextInput title={'City:'} setTo={setTrade2City} complete={trade2CityComplete} width={140} required={true} active={tradeReferencesInformationActive} under={true} initializedValue={trade2City}/>
                <TextInput title={'State/Province:'} setTo={setTrade2State} complete={trade2StateComplete} charCount={2} width={40} required={true} active={tradeReferencesInformationActive} under={true} initializedValue={trade2State}/>
                <TextInput title={'Zip:'} setTo={setTrade2Zip} complete={trade2ZipComplete} charCount={6} required={true} active={tradeReferencesInformationActive} under={true} initializedValue={trade2Zip}/>
                <TextInput title={'Country:'} setTo={setTrade2Country} complete={trade2CountryComplete} charCount={2} required={false} active={tradeReferencesInformationActive} under={true} initializedValue={trade2Country}/>
                
            </div>
            }

            <div className='External-Form-Spacer'/>

            {   secondaryReference && !thirdReference && 
                <button onClick={() => setThirdReference(true)} className='External-Customer-Contact-Button Button-Add'>Add Third Reference</button>
            }
            {   thirdReference && secondaryReference &&
                <button onClick={() => setThirdReference(false)} className='External-Customer-Contact-Button Button-Remove'>Remove Third Reference</button>
            }

            { thirdReference && secondaryReference &&
            <div className='External-Trade-Group'> 
            <TextInput title={'Company Name:'} setTo={setCompanyName3} complete={companyName3Complete} width={340} required={true} active={tradeReferencesInformationActive} initializedValue={companyName3}/>
            <TextInput title={'Contact First Name:'} setTo={setContactFirstName3} complete={contactTradeFirstName3Complete} width={170} required={true} active={tradeReferencesInformationActive} initializedValue={contactFirstName3}/>
            <TextInput title={'Contact Last Name:'} setTo={setContactLastName3} complete={contactTradeLastName3Complete} width={170} required={true} active={tradeReferencesInformationActive} initializedValue={contactLastName3}/>
            <TextInput title={'Title:'} setTo={setTradeTitle3} complete={tradeTitle3Complete} width={170} required={true} active={tradeReferencesInformationActive} initializedValue={tradeTitle3}/>
            <TextInput title={'Email Address:'} setTo={setTradeEmail3} complete={tradeEmail3Complete} width={280} required={true} active={tradeReferencesInformationActive} initializedValue={tradeEmail3}/>
            <TextInput title={'Phone:'} setTo={setTradePhone3} complete={tradePhone3Complete} charCount={10} required={true} active={tradeReferencesInformationActive} initializedValue={tradePhone3}/>
            <TextInput title={'Extension:'} setTo={setTradeExtension3}  charCount={6} required={false} active={tradeReferencesInformationActive} initializedValue={tradeExtension3}/>
            
            <div className='External-Form-Spacer'/>

            <div className='External-Form-Input-Title'>Contact Address:</div>

            <TextInput title={'Street:'} setTo={setTrade3Street}complete={trade3StreetComplete} width={220} required={true} active={tradeReferencesInformationActive} under={true} initializedValue={trade3Street}/>
            <TextInput title={'Street2:'} setTo={setTrade3Street2} width={120} required={false} active={tradeReferencesInformationActive} under={true} initializedValue={trade3Street2}/>
            <TextInput title={'City:'} setTo={setTrade3City} complete={trade3CityComplete} width={140} required={true} active={tradeReferencesInformationActive} under={true} initializedValue={trade3City}/>
            <TextInput title={'State/Province:'} setTo={setTrade3State} complete={trade3StateComplete} charCount={2} width={40} required={true} active={tradeReferencesInformationActive} under={true} initializedValue={trade3State}/>
            <TextInput title={'Zip:'} setTo={setTrade3Zip} complete={trade3ZipComplete} charCount={6} required={true} active={tradeReferencesInformationActive} under={true} initializedValue={trade3Zip}/>
            <TextInput title={'Country:'} setTo={setTrade3Country} complete={trade3CountryComplete} charCount={2} required={false} active={tradeReferencesInformationActive} under={true} initializedValue={trade3Country}/>
            </div>
            }

            <div className='External-Form-Input-Row-Files'>
                <FaStar className='External-Form-Input-Not-Required' />
                <div className='External-Form-Input-Title'>PDF version of Trade References:</div>
                <input type='file' accept="application/pdf" onChange={(e) => setTradeReferencesFile(e.target.files)} className='External-Form-File-Upload'/>
            </div>
            
        </div>
    )
};

// CREDIT CARD INFORMATION SECTION
const CreditCardInformation = ({creditCardActive,setNameOnCard,nameOnCard,nameOnCardComplete,setCardNumber,cardNumber,cardNumberComplete,setExpDate,expDate,
    expDateComplete,setCvv,cvv,cvvComplete,setCardZip,cardZip,cardZipComplete}) => {

    return(
        <div className='External-Information-Section'>            
            <div className='External-Form-Input-Title-Row'>Credit Card Information:</div>

            <div className='External-Card-Information-Group'>
                <TextInput title={'Name On Card:'} setTo={setNameOnCard} complete={nameOnCardComplete} width={340} required={true} active={creditCardActive} initializedValue={nameOnCard}/>
                <TextInput title={'Card Number:'} setTo={setCardNumber} complete={cardNumberComplete} width={340} charCount={19} required={true} active={creditCardActive} initializedValue={cardNumber}/>
                
                <div className='External-Form-Spacer'/>

                <TextInput title={'Exp Date:'} setTo={setExpDate} complete={expDateComplete} width={140} required={true} active={creditCardActive} initializedValue={expDate}/>
                <TextInput title={'Security Code:'} setTo={setCvv} complete={cvvComplete} charCount={4}  required={true} active={creditCardActive} initializedValue={cvv}/>
                <TextInput title={'Zip:'} setTo={setCardZip} complete={cardZipComplete} charCount={5} required={true} active={creditCardActive} initializedValue={cardZip}/>
            </div>
        </div>
    )
};

// ACH INFORMATION SECTION
const AchInformation = ({achActive,setBankName,bankName,bankNameComplete,setBankContactFirstName,bankContactFirstName,setBankContactLastName,bankContactLastName,bankContactFirstNameComplete,bankContactLastNameComplete,
    setBankStreet,bankStreet,setBankStreet2,bankStreet2,bankStreetComplete,setBankCity,bankCity,bankCityComplete,setBankState,bankState,bankStateComplete,
    setBankZip,bankZip,bankZipComplete,setBankCountry,bankCountry,bankCountryComplete,setBankTelephone,bankTelephone,bankTelephoneComplete,
    setBankExtension,bankExtension,setBankContactTitle,bankContactTitle,bankContactTitleComplete,setBankContactEmail,bankContactEmail,bankContactEmailComplete,
    setBankAccountName,bankAccountName,bankAccountNameComplete,setBankAccountNumber,bankAccountNumber,bankAccountNumberComplete,setBankRoutingNumber,bankRoutingNumber,
    bankRoutingNumberComplete,setBankSwiftCode,bankSwiftCode,bankSwiftCodeComplete,setBankAccountSelection,bankAccountSelection,bankAccountSelectionComplete}) => {
    
    const [ checkingSelected, setCheckingSelected ] = useState(true);
    const [ savingsSelected, setSavingsSelected ] = useState(false);
    const [ addressComplete, setAddressComplete] = useState(false);

    useEffect(() => {
        if(bankStateComplete && bankCityComplete && bankStateComplete && bankZipComplete) setAddressComplete(true);
        else setAddressComplete(false);
    },[bankStateComplete,bankCityComplete,bankStateComplete,bankZipComplete]);


    const toggleSelection = (value) => {
        if(value === 'Checking'){
            setSavingsSelected(false);
            setCheckingSelected(true);
            setBankAccountSelection('Checking');
        }
        else{
            setSavingsSelected(true);
            setCheckingSelected(false);
            setBankAccountSelection('Savings');
        }
    };

    useEffect(() => {
        if(bankAccountSelection === 'Checking'){
            setSavingsSelected(false);
            setCheckingSelected(true);
        }
        else{
            setSavingsSelected(true);
            setCheckingSelected(false);
        }
    },[bankAccountSelection]);

    return(
        <div className='External-Information-Section'>
            {   achActive &&
                <>
                <div className='External-Customer-Title'>
                    Please enter all required ACH fields to continue.
                </div>
                </>
            }

            <div className='External-Form-Input-Title-Row'>ACH Bank Information:</div>
                
            <TextInput title={'Bank Name:'} setTo={setBankName} complete={bankNameComplete} width={280} required={true} active={achActive} initializedValue={bankName}/>
            <TextInput title={'Name on Account:'} setTo={setBankAccountName} complete={bankAccountNameComplete} width={300} required={true} active={achActive} initializedValue={bankAccountName}/>

            <div className='External-Form-Spacer'>
            </div>
            <div className='External-Form-Input-Title'>Bank Address:</div>
            <TextInput title={'Street:'} setTo={setBankStreet}complete={bankStreetComplete} width={220} required={true} active={achActive} under={true} initializedValue={bankStreet}/>
            <TextInput title={'Street2:'} setTo={setBankStreet2} width={120} required={false} active={achActive} under={true} initializedValue={bankStreet2}/>
            <TextInput title={'City:'} setTo={setBankCity} complete={bankCityComplete} width={140} required={true} active={achActive} under={true} initializedValue={bankCity}/>
            <TextInput title={'State/Province:'} setTo={setBankState} complete={bankStateComplete} charCount={2} width={40} required={true} active={achActive} under={true} initializedValue={bankState}/>
            <TextInput title={'Zip:'} setTo={setBankZip} complete={bankZipComplete} charCount={6} required={true} active={achActive} under={true} initializedValue={bankZip}/>
            <TextInput title={'Country:'} setTo={setBankCountry} complete={bankCountryComplete} charCount={2} required={false} active={achActive} under={true} initializedValue={bankCountry}/>
            
            <div className='External-Form-Spacer'/>

            <TextInput title={'Bank Telephone:'} setTo={setBankTelephone} complete={bankTelephoneComplete} charCount={10} required={true} active={achActive} initializedValue={bankTelephone}/>
            <TextInput title={'Bank Telephone Extension:'} setTo={setBankExtension} charCount={6} required={false} active={achActive}  initializedValue={bankExtension}/>
            <TextInput title={'Bank Contact First Name:'} setTo={setBankContactFirstName} complete={bankContactFirstNameComplete} width={150} required={true} active={achActive} initializedValue={bankContactFirstName}/>
            <TextInput title={'Bank Contact Last Name:'} setTo={setBankContactLastName} complete={bankContactLastNameComplete} width={150} required={true} active={achActive} initializedValue={bankContactLastName}/>
            <TextInput title={'Bank Contact Title:'} setTo={setBankContactTitle} complete={bankContactTitleComplete} width={150} required={true} active={achActive} initializedValue={bankContactTitle}/>
            <TextInput title={'Bank Contact Email:'} setTo={setBankContactEmail} complete={bankContactEmailComplete} width={300} required={true} active={achActive} initializedValue={bankContactEmail}/>
            <TextInput title={'Account Number:'} setTo={setBankAccountNumber} complete={bankAccountNumberComplete} charCount={17} required={true} active={achActive} initializedValue={bankAccountNumber}/>
            <TextInput title={'Routing Number:'} setTo={setBankRoutingNumber} complete={bankRoutingNumberComplete} charCount={9} required={true} active={achActive} initializedValue={bankRoutingNumber}/>

            <AccountSelector title={'Checking'} selected={checkingSelected} setTo={() => toggleSelection('Checking')}/>
            <AccountSelector title={'Savings'} selected={savingsSelected} setTo={() => toggleSelection('Savings')}/>

            </div>
    )
};    

// REQUIRED FILES SECTION
const RequiredFilesSection = ({filesActive,
    w9Shown,w9,setW9,w9Active,
    creditReferenceSheet,creditReferenceSheetShown,creditReferenceSheetActive,setCreditReferenceSheet,
    voidedCheckShown,voidedCheckFile,voidedCheckActive,setVoidedCheckFile,
    intWireShown,intWire,intWireActive,setIntWire,
    taxCertShown,taxCert,taxCertActive,setTaxCert,
    rejectionRecord}) => {

    return(
        <div className='External-Information-Section'>
            {   filesActive &&
                <>
                <div className='External-Customer-Title'>
                    Please upload all requested files below to continue.
                </div>
                </>
            }


            <div className='External-Form-Spacer'/>

            <div className='External-Form-Input-Title-Row'>Required Files:</div>

            {   rejectionRecord &&
                <div className='External-Customer-Title'>
                    Uploading a file will overwrite the previous version.
                </div>
            }

            {   w9Shown &&
                <div className='External-Form-Input-Row-Files'>
                    {   w9Active && 
                        <>
                            {   !w9 && !rejectionRecord &&
                                <FaStar className='External-Form-Input-Required' />
                            }
                            {   w9 && 
                                <FaCheck className='External-Form-Input-Complete' />
                            }
                            { rejectionRecord && !w9 && !rejectionRecord.customerProfile.w9 &&
                                <FaStar className='External-Form-Input-Required' />
                            }
                            { rejectionRecord && !w9 && rejectionRecord.customerProfile.w9 &&
                                <FaStar className='External-Form-Input-Not-Required' />
                            }
                        </> 
                    }
                    <div className='External-Form-Input-Title'>PDF version of completed W9:</div>
                    <button className='External-Form-Blank-Button' onClick={() => getBlankW9()}>Download Blank W9</button>
                    <input type='file' accept="application/pdf" onChange={(e) => setW9(e.target.files)} className='External-Form-File-Upload'/>
                </div>
            }


            { creditReferenceSheetShown &&
            <div className='External-Form-Input-Row-Files'>
                {   creditReferenceSheetActive &&
                    <>
                        {   !creditReferenceSheet && !rejectionRecord &&
                            <FaStar className='External-Form-Input-Required' />
                        }
                        {   creditReferenceSheet &&
                            <FaCheck className='External-Form-Input-Complete' />
                        }
                        {   rejectionRecord && !creditReferenceSheet && !rejectionRecord.customerProfile.creditSheet &&
                            <FaStar className='External-Form-Input-Required' />
                        }
                        {   rejectionRecord && !creditReferenceSheet && rejectionRecord.customerProfile.creditSheet &&
                            <FaStar className='External-Form-Input-Not-Required' />
                        }
                    </>
                }
                <div className='External-Form-Input-Title'>PDF version of Credit Reference Sheet:</div>
                <input type='file' accept="application/pdf" onChange={(e) => setCreditReferenceSheet(e.target.files)} className='External-Form-File-Upload'/>
            </div>
            }

            {   voidedCheckShown &&
            <div className='External-Form-Input-Row-Files'>
                {   voidedCheckActive &&
                    <>
                        {   !voidedCheckFile && !rejectionRecord &&
                            <FaStar className='External-Form-Input-Required' />
                        }
                        {   voidedCheckFile && 
                            <FaCheck className='External-Form-Input-Complete' />
                        }
                        {   rejectionRecord && !voidedCheckFile && !rejectionRecord.customerProfile.voidedCheck &&
                            <FaStar className='External-Form-Input-Required' />
                        }
                        {   rejectionRecord && !voidedCheckFile && rejectionRecord.customerProfile.voidedCheck &&
                            <FaStar className='External-Form-Input-Not-Required' />
                        }
                    </>
                }

                <div className='External-Form-Input-Title'>PDF version of Voided Check or Bank Letter:</div>
                <input type='file' accept="application/pdf" onChange={(e) => setVoidedCheckFile(e.target.files)} className='External-Form-File-Upload'/>
            </div>
            }

            {   intWireShown &&
            <div className='External-Form-Input-Row-Files'>
                {   intWireActive &&
                    <>
                        {   !intWire && !rejectionRecord &&
                            <FaStar className='External-Form-Input-Required' />
                        }
                        {   intWire && 
                            <FaCheck className='External-Form-Input-Complete' />
                        }
                        {   rejectionRecord && !intWire && !rejectionRecord.customerProfile.internationalWire &&
                            <FaStar className='External-Form-Input-Required' />
                        }
                        {   rejectionRecord && !intWire && rejectionRecord.customerProfile.internationalWire &&
                            <FaStar className='External-Form-Input-Not-Required' />
                        }
                    </>
                }
                <div className='External-Form-Input-Title'>PDF version of Wire Instructions:</div>
                <input type='file' accept="application/pdf" onChange={(e) => setIntWire(e.target.files)} className='External-Form-File-Upload'/>
            </div>
            }

            {   taxCertShown &&
            <div className='External-Form-Input-Row-Files'>
                {   taxCertActive &&
                    <>
                        {   !taxCert &&
                            <FaStar className='External-Form-Input-Not-Required' />
                        }
                        { taxCert &&
                            <FaCheck className='External-Form-Input-Complete' />
                        }
                    </>
                }
                <div className='External-Form-Input-Title'>PDF version of Certificate of Tax Exemption:</div>
                <input type='file' accept="application/pdf" onChange={(e) => setTaxCert(e.target.files)} className='External-Form-File-Upload'/>
            </div>
            }
        </div>
    )

};

// CONDITIONS SECTION
const ConditionsAndAuthorizations = ({conditionsActive,setNameSign,nameSign,nameSignComplete,setTitleSign,titleSign,titleSignComplete,
    setSignature,signatureComplete,setDate,date,dateComplete,setSecondarySignature,secondarySignature,setNameSign2,nameSign2,nameSign2Complete,setTitleSign2,titleSign2,titleSign2Complete,
    setSignature2,signature2Complete,setDate2,date2,date2Complete}) => {
        const conditionString = 'We certify that we are authorized to provide this information, and that the information on this form is correct to the best of our knowledge. We affirm financial responsibility, and it is understood that payment terms are net thirty (30) days and that any balances not paid within these terms shall be subject to a late charge. We agree to pay a monthly finance charge of 1.50% per month or 18% annually on all balances more than thirty (30) days past due. We acknowledge that any invoice more than sixty (60) days past due shall be sent to a collection agency. We agree to pay all costs of collection and litigation on this account, and by signing below, we acknowledge and agree that any legal proceeding or dispute related to this form or the relationship between the parties named herein will be governed by and interpreted according to the laws of the State of Alabama. We agree that all decisions with respect to the extension or continuation of business shall be in the sole discretion of the Seller.'
        return(

            <div className='External-Information-Section'>
                {   conditionsActive &&
                    <>
                    <div className='External-Customer-Title'>
                        Please verify the terms and conditions to submit the customer form.
                    </div>
                    </>
                }

                <div className='External-Form-Input-Title-Row'>Conditions and Authorizations:</div>

                <div className='External-Terms-Text'>{conditionString}</div>
            
                <div className='External-Conditions-Informmation'>
                <TextInput title={`Full Name:`} setTo={setNameSign} complete={nameSignComplete} width={220} required={true} initializedValue={nameSign}/>
                <TextInput title={`Title:`} setTo={setTitleSign} complete={titleSignComplete} width={170} required={true} initializedValue={titleSign}/>
                <SignatureInput title={`Signature:`} setTo={setSignature} complete={signatureComplete} width={220}/>
                <TextInput title={`Date:`} setTo={setDate} complete={dateComplete} width={100} required={true} initializedValue={date} disabled={true}/>

                    {   !secondarySignature && 
                        <button onClick={() => setSecondarySignature(true)} className='External-Customer-Trade-Reference-Button Button-Add'>Add Second Signer</button>
                    }
                    {   secondarySignature && 
                    <button onClick={() => setSecondarySignature(false)} className='External-Customer-Trade-Reference-Button Button-Remove'>Remove Second Signature</button>
                    }

                { secondarySignature && 
                <div className='External-Conditions-Informmation'>
                    <TextInput title={`Name:`} setTo={setNameSign2} complete={nameSign2Complete} width={220} required={true} initializedValue={nameSign2}/>
                    <TextInput title={`Title:`} setTo={setTitleSign2} complete={titleSign2Complete} width={170} required={true} initializedValue={titleSign2}/>
                    <SignatureInput title={'Signature:'} setTo={setSignature2} complete={signature2Complete} width={220}/>
                    <TextInput title={`Date:`} setTo={setDate2} complete={date2Complete} width={100} required={true} initializedValue={date2} disabled={true}/>
                </div>
                }
                </div>
            </div>
        )
};

// FORM SUBMISSION - - - - - - - -
const FormSubmissionWindow = ({
    voidedCheckFile,voidedCheckFileId,voidedCheckError,
    taxCert,taxCertId,taxCertError,
    w9,w9Id,w9Error,
    intWire, intWireId,intWireError,
    creditReferenceSheet,creditReferenceSheetId,creditReferenceSheetError,
    tradeReferencesFile, tradeReferencesFileId,tradeReferencesFileError,
    formSubmissionValid}) => {
    // FILES SECTION HELPER FUNCTION
    const FileSection = ({loading, error, title, seperator=false}) => {
        return(
            <div className='External-Form-Submission-Section'>
                <div className='External-Form-Submission-File-Group'>
                    <div className='External-Form-Submission-Status'>
                        {   loading && !error &&
                            <LoadingSpinner size={60}/>
                        }     
                        {   !loading && !error &&
                            <HiBadgeCheck className='External-Form-Accepted' />
                        }
                        {   error &&
                            <IoWarning className='External-Form-Error' />
                        }
                    </div>
                    <div className='External-Form-Submission-Title'>
                        {title}
                    </div>
                </div>
                {   seperator &&
                    <FaDotCircle className='External-Form-Submission-Seperator'/>
                }
            </div>
        )
    };
    
    return(
        <div className='External-Form-Submission-Window'>            
            {   w9 && 
                <FileSection loading={!w9Id} error={w9Error} title={'Submitting W9'} seperator={true}/>
            }
            {   voidedCheckFile &&
                <FileSection loading={!voidedCheckFileId} error={voidedCheckError} title={'Submitting Voided Check'} seperator={true}/>
            }
            {   taxCert &&
                <FileSection loading={!taxCertId} error={taxCertError} title={'Submitting Tax Certificate'} seperator={true}/>
            }
            {   intWire &&
                <FileSection loading={!intWireId} error={intWireError} title={'Submitting Wire Instructions'} seperator={true}/>
            }
            {   creditReferenceSheet &&
                <FileSection loading={!creditReferenceSheetId} error={creditReferenceSheetError} title={'Submitting Credit Reference Sheet'} seperator={true}/>
            }
            {   tradeReferencesFile &&
                <FileSection loading={!tradeReferencesFileId} error={tradeReferencesFileError} title={'Submitting Trade Reference Sheet'} seperator={true}/>
            }
            

            <FileSection loading={!formSubmissionValid} title={'Submitting Complete Customer Request'}/>

            {   formSubmissionValid &&
                <div className='External-Form-Submission-Success'>
                    We have received your information. Thank you!
                </div>
            }

        </div>
    )
};

//Rejection
const RejectionHeader = ({rejectionRecord}) => {

    
    return(
        <div className='Rejection-Header'>
            <div className='Rejection-Header-Title'>
                Your request has been rejected for the following reasons:
            </div>
            <div className='Rejection-Header-Text'>
                {rejectionRecord.text}
            </div>
            <div className='Rejection-Header-Instructions'>
                Please update below and resubmit.
            </div>
        </div>
    )
};

// PRIMARY FUNCTION - - - - - - - - -
const NewCustomer = () => {
    const { email } = useParams();
    const [ notificationEmail, setNotificationEmail ] = useState(email);
    useEffect(() => {
        if(email && email != 'null') setNotificationEmail(email);
    },[email]);

    // DEFAULTS
    const formEmail = 'For questions or support, please email: AR@cornerstoneinc.com';
    const businessTypeOptions = ['Corporation', 'Partnership' , 'Sole Proprietorship', 'Limited Liability Company (LLC)', 'Government'];
    const paymentOptions = ['Credit Card', 'ACH', 'Wire'];
    const customerClassOptions = ['General Contractor', 'Subcontractor', 'Owner Federal','Owner State','Owner County', 'Owner Local','Owner Local Maintenance', 'Wholesale'];
    const taxExemptOptions = ['Yes', 'No'];
    const poOptions = ['Yes', 'No'];
    const params = useSearchParams(); 

    // COMPANY INFORMATION STATE
    const [ customerInformationActive, setCustomerInformationActive] = useState(true);
    const [ customerInformationComplete, setCustomerInformationComplete ] = useState(false);
    const [ fedEinSSn, setFedEinSSn ] = useState('');
    const [ fedEinSSnComplete, setFedEinSSnComplete ] = useState(false);
    const [ website, setWebsite ] = useState('');
    const [ websiteComplete, setwebsiteComplete ] = useState(false);
    const [ dunsNo, setDunsNo ] = useState('');
    const [ dunsNoComplete, setdunsNoComplete ] = useState(false);
    const [ legalName, setLegalName ] = useState('');
    const [ legalNameComplete, setLegalNameComplete ] = useState(false);
    const [ tradeNameDBA, setTradeNameDBA ] = useState('');
    const [ tradeNameDBAComplete, setTradeNameDBAComplete ] = useState(false);
    const [ street, setStreet ] = useState('');
    const [ street2, setStreet2 ] = useState('');
    const [ streetComplete, setStreetComplete ] = useState(false);
    const [ city, setCity ] = useState('');
    const [ cityComplete, setCityComplete ] = useState(false);
    const [ state, setState ] = useState('');
    const [ stateComplete, setStateComplete ] = useState(false);
    const [ zip, setZip ] = useState('');
    const [ zipComplete, setZipComplete ] = useState(false);
    const [ country, setCountry ] = useState('');
    const [ shippingStreet, setShippingStreet ] = useState('');
    const [ shippingStreet2, setShippingStreet2 ] = useState('');
    const [ shippingStreetComplete, setShippingStreetComplete ] = useState(false);
    const [ shippingCity, setShippingCity ] = useState('');
    const [ shippingCityComplete, setShippingCityComplete ] = useState(false);
    const [ shippingState, setShippingState ] = useState('');
    const [ shippingStateComplete, setShippingStateComplete ] = useState(false);
    const [ shippingZip, setShippingZip ] = useState('');
    const [ shippingZipComplete, setShippingZipComplete ] = useState(false);
    const [ shippingCountry, setShippingCountry ] = useState('');
    const [ taxExemptCert, setTaxExemptCert ] = useState();
    const [ taxExemptCertComplete, setTaxExemptCertComplete ] = useState(false);
    const [ paymentMethod, setPaymentMethod ] = useState('');
    const [ paymentMethodComplete, setPaymentMethodComplete ] = useState(false);
    const [ businessTypeSelection , setBusinessTypeSelection ] = useState('');
    const [ businessTypeSelectionComplete, setBusinessTypeSelectionComplete ] = useState(false);
    const [ stateOfInc, setStateOfInc ] = useState('');
    const [ stateOfIncComplete, setStateOfIncComplete ] = useState(false);
    const [ poRequired, setPoRequired ] = useState();
    const [ poRequiredComplete, setPoRequiredComplete ] = useState();
    const [ invoiceCurrency, setInvoiceCurrency ] = useState('USD');
    const [ invoiceCurrencyComplete, setInvoiceCurrencyComplete ] = useState(false);
    const [ customerClassSelection, setCustomerClassSelection ] = useState('');
    const [ customerClassSelectionComplete, setCustomerClassSelectionComplete ] = useState(false);

    // PRIMARY CONTACT
    const [ primaryContactAndApActive, setPrimaryContactAndApActive] = useState(false);
    const [ primaryAndAPComplete, setPrimaryAndAPComplete] = useState(false);
    const [ primaryContactFirstName, setPrimaryContactFirstName ] = useState('');
    const [ primaryContactLastName, setPrimaryContactLastName ] = useState('');
    const [ primaryContactFirstNameComplete, setPrimaryContactFirstNameComplete ] = useState(false);
    const [ primaryContactLastNameComplete, setPrimaryContactLastNameComplete ] = useState(false);
    const [ primaryContactNumber, setPrimaryContactNumber ] = useState('');
    const [ primaryContactNumberComplete, setPrimaryContactNumberComplete ] = useState(false);
    const [ primaryExtension, setPrimaryExtension ] = useState('');
    const [ primaryTitle, setPrimaryTitle ] = useState('');
    const [ primaryTitleComplete, setPrimaryTitleComplete ] = useState(false);
    const [ primaryContactEmail, setPrimaryContactEmail ] = useState('');
    const [ primaryContactEmailComplete, setPrimaryContactEmailComplete ] = useState(false);
    const [ primaryStreet, setPrimaryStreet ] = useState('');
    const [ primaryStreetComplete, setPrimaryStreetComplete ] = useState(false);
    const [ primaryStreet2, setPrimaryStreet2 ] = useState('');
    const [ primaryCity, setPrimaryCity ] = useState('');
    const [ primaryCityComplete, setPrimaryCityComplete ] = useState(false);
    const [ primaryState, setPrimaryState ] = useState('');
    const [ primaryStateComplete, setPrimaryStateComplete ] = useState(false);
    const [ primaryZip, setPrimaryZip ] = useState('');
    const [ primaryZipComplete, setPrimaryZipComplete ] = useState(false);
    const [ primaryCountry, setPrimaryCountry ] = useState('');
    // AP CONTACT STATE
    const [ contactFirstNameAP, setContactFirstNameAP ] = useState('');
    const [ contactLastNameAP, setContactLastNameAP ] = useState('');
    const [ contactFirstNameAPComplete, setContactFirstNameAPComplete ] = useState(false);
    const [ contactLastNameAPComplete, setContactLastNameAPComplete ] = useState(false);
    const [ phoneAP, setPhoneAP ] = useState('');
    const [ extensionAP, setExtensionAP ] = useState('');
    const [ titleAP, setTitleAP ] = useState('');
    const [ titleAPComplete, settitleAPComplete ] = useState('');
    const [ phoneAPComplete, setPhoneAPComplete ] = useState(false);
    const [ contactEmailAP, setContactEmailAP ] = useState('');
    const [ contactEmailAPComplete, setContactEmailAPComplete ] = useState(false);

    // OWNERS OR AUTHORIZED OFFICERS STATE
    const [ ownersOrOfficersInformationActive, setOwnersOrOfficersInformationActive ] = useState('');
    const [ ownersOrOfficersInformationComplete, setOwnersOrOfficersInformationComplete ] = useState('');
    const [ firstName1, setFirstName1 ] = useState('');
    const [ lastName1, setLastName1 ] = useState('');
    const [ ownerFirstName1Complete, setOwnerFirstName1Complete ] = useState(false);
    const [ ownerLastName1Complete, setOwnerLastName1Complete ] = useState(false);
    const [ title, setTitle ] = useState('');
    const [ titleComplete, setTitleComplete ] = useState(false);
    const [ phone, setPhone ] = useState('');
    const [ phoneComplete, setPhoneComplete ] = useState(false);
    const [ extension, setExtension ] = useState('');
    const [ ownerStreet, setOwnerStreet ] = useState('');
    const [ ownerStreetComplete, setOwnerStreetComplete ] = useState(false);
    const [ ownerStreet2, setOwnerStreet2 ] = useState('');
    const [ ownerCity, setOwnerCity ] = useState('');
    const [ ownerCityComplete, setOwnerCityComplete ] = useState(false);
    const [ ownerState, setOwnerState ] = useState('');
    const [ ownerStateComplete, setOwnerStateComplete ] = useState(false);
    const [ ownerZip, setOwnerZip ] = useState('');
    const [ ownerZipComplete, setOwnerZipComplete ] = useState(false);
    const [ ownerCountry, setOwnerCountry ] = useState('');
    const [ emailAddress, setEmailAddress ] = useState('');
    const [ emailAddressComplete, setEmailAddressComplete ] = useState(false);
    const [ secondaryOwner, setSecondaryOwner ] = useState(false);
    const [ firstName2, setFirstName2 ] = useState('');
    const [ lastName2, setLastName2 ] = useState('');
    const [ ownerFirstName2Complete, setOwnerFirstName2Complete ] = useState(false);
    const [ ownerLastName2Complete, setOwnerLastName2Complete ] = useState(false);
    const [ title2, setTitle2 ] = useState('');
    const [ title2Complete, setTitle2Complete ] = useState(false);
    const [ phone2, setPhone2 ] = useState('');
    const [ phone2Complete, setPhone2Complete ] = useState(false);
    const [ extension2, setExtension2 ] = useState('');
    const [ owner2Street, setOwner2Street ] = useState('');
    const [ owner2StreetComplete, setOwner2StreetComplete ] = useState(false);
    const [ owner2Street2, setOwner2Street2 ] = useState('');
    const [ owner2City, setOwner2City ] = useState('');
    const [ owner2CityComplete, setOwner2CityComplete ] = useState(false);
    const [ owner2State, setOwner2State ] = useState('');
    const [ owner2StateComplete, setOwner2StateComplete ] = useState(false);
    const [ owner2Zip, setOwner2Zip ] = useState('');
    const [ owner2ZipComplete, setOwner2ZipComplete ] = useState(false);
    const [ owner2Country, setOwner2Country ] = useState('');
    const [ emailAddress2, setEmailAddress2 ] = useState('');
    const [ emailAddress2Complete, setEmailAddress2Complete ] = useState(false);

    // TRADE REFERENCES STATE
    const [ tradeReferencesInformationActive, setTradeReferencesInformationActive ] = useState(false);
    const [ tradeReferencesInformationComplete, setTradeReferencesInformationComplete ] = useState(false);
    const [ tradeReferencesFile, setTradeReferencesFile ] = useState();
    const [ tradeReferencesFileId, setTradeReferencesFileId ] = useState();
    const [ tradeReferencesFileError, setTradeReferencesFileError ] = useState();
    const [ companyName, setCompanyName ] = useState('');
    const [ companyNameComplete, setCompanyNameComplete ] = useState(false);
    const [ contactFirstName, setContactFirstName ] = useState('');
    const [ contactLastName, setContactLastName ] = useState('');
    const [ contactTradeFirstNameComplete, setContactTradeFirstNameComplete ] = useState(false);
    const [ contactTradeLastNameComplete, setContactTradeLastNameComplete ] = useState(false);
    const [ tradeTitle, setTradeTitle ] = useState('');
    const [ tradeTitleComplete, setTradeTitleComplete ] = useState(false);
    const [ tradeEmail, setTradeEmail ] = useState('');
    const [ tradeEmailComplete, setTradeEmailComplete ] = useState(false);
    const [ tradePhone, setTradePhone ]  = useState('');
    const [ tradePhoneComplete, setTradePhoneComplete ] = useState(false);
    const [ tradeExtension, setTradeExtension ]  = useState('');
    const [ tradeStreet, setTradeStreet ] = useState('');
    const [ tradeStreetComplete, setTradeStreetComplete ] = useState(false);
    const [ tradeStreet2, setTradeStreet2 ] = useState('');
    const [ tradeCity, setTradeCity ] = useState('');
    const [ tradeCityComplete, setTradeCityComplete ] = useState(false);
    const [ tradeState, setTradeState ] = useState('');
    const [ tradeStateComplete, setTradeStateComplete ] = useState(false);
    const [ tradeZip, setTradeZip ] = useState('');
    const [ tradeZipComplete, setTradeZipComplete ] = useState(false);
    const [ tradeCountry, setTradeCountry ] = useState('');
    const [ tradeCountryComplete, setTradeCountryComplete ] = useState(false);
    const [ secondaryReference, setSecondaryReference ] = useState(false);
    const [ companyName2, setCompanyName2 ] = useState('');
    const [ companyName2Complete, setCompanyName2Complete ] = useState(false);
    const [ contactFirstName2, setContactFirstName2 ] = useState('');
    const [ contactLastName2, setContactLastName2 ] = useState('');
    const [ contactTradeFirstName2Complete, setContactTradeFirstName2Complete ] = useState(false);
    const [ contactTradeLastName2Complete, setContactTradeLastName2Complete ] = useState(false);
    const [ tradeTitle2, setTradeTitle2 ] = useState('');
    const [ tradeTitle2Complete, setTradeTitle2Complete ] = useState(false);
    const [ tradeEmail2, setTradeEmail2 ] = useState('');
    const [ tradeEmail2Complete, setTradeEmail2Complete ] = useState(false);
    const [ tradePhone2, setTradePhone2 ]  = useState('');
    const [ tradePhone2Complete, setTradePhone2Complete ] = useState(false);
    const [ tradeExtension2, setTradeExtension2 ]  = useState('');
    const [ trade2Street, setTrade2Street ] = useState('');
    const [ trade2StreetComplete, setTrade2StreetComplete ] = useState(false);
    const [ trade2Street2, setTrade2Street2 ] = useState('');
    const [ trade2City, setTrade2City ] = useState('');
    const [ trade2CityComplete, setTrade2CityComplete ] = useState(false);
    const [ trade2State, setTrade2State ] = useState('');
    const [ trade2StateComplete, setTrade2StateComplete ] = useState(false);
    const [ trade2Zip, setTrade2Zip ] = useState('');
    const [ trade2ZipComplete, setTrade2ZipComplete ] = useState('');
    const [ trade2Country, setTrade2Country ] = useState('');
    const [ trade2CountryComplete, setTrade2CountryComplete ] = useState(false);
    const [ thirdReference, setThirdReference ] = useState(false);
    const [ companyName3, setCompanyName3 ] = useState('');
    const [ companyName3Complete, setCompanyName3Complete ] = useState(false);
    const [ contactFirstName3, setContactFirstName3 ] = useState('');
    const [ contactLastName3, setContactLastName3 ] = useState('');
    const [ contactTradeFirstName3Complete, setContactTradeFirstName3Complete ] = useState(false);
    const [ contactTradeLastName3Complete, setContactTradeLastName3Complete ] = useState(false);
    const [ tradeTitle3, setTradeTitle3 ] = useState('');
    const [ tradeTitle3Complete, setTradeTitle3Complete ] = useState(false);
    const [ tradeEmail3, setTradeEmail3 ] = useState('');
    const [ tradeEmail3Complete, setTradeEmail3Complete ] = useState(false);
    const [ tradePhone3, setTradePhone3 ]  = useState('');
    const [ tradePhone3Complete, setTradePhone3Complete ] = useState(false);
    const [ tradeExtension3, setTradeExtension3 ]  = useState('');
    const [ trade3Street, setTrade3Street ] = useState('');
    const [ trade3StreetComplete, setTrade3StreetComplete ] = useState(false);
    const [ trade3Street2, setTrade3Street2 ] = useState('');
    const [ trade3City, setTrade3City ] = useState('');
    const [ trade3CityComplete, setTrade3CityComplete ] = useState(false);
    const [ trade3State, setTrade3State ] = useState('');
    const [ trade3StateComplete, setTrade3StateComplete ] = useState(false);
    const [ trade3Zip, setTrade3Zip ] = useState('');
    const [ trade3ZipComplete, setTrade3ZipComplete ] = useState('');
    const [ trade3Country, setTrade3Country ] = useState('');
    const [ trade3CountryComplete, setTrade3CountryComplete ] = useState(false);

    // PAYMENT INFORMATION STATE
    const [ paymentInformationComplete, setPaymentInformationComplete ] = useState(false);
    // CREDIT CARD
    const [ creditCardShown, setCreditCardShown] = useState(false);
    const [ creditCardActive, setCreditCardActive ] = useState(false);
    const [ creditCardComplete, setCreditCardComplete ] = useState(false);
    const [ nameOnCard, setNameOnCard ] = useState('');
    const [ nameOnCardComplete, setNameOnCardComplete ] = useState(false);
    const [ cardNumber, setCardNumber ] = useState('');
    const [ cardNumberComplete, setCardNumberComplete ] = useState(false);
    const [ expDate, setExpDate ] = useState('');
    const [ expDateComplete, setExpDateComplete ] = useState(false);
    const [ cvv, setCvv ] = useState('');
    const [ cvvComplete, setCvvComplete ] = useState(false);
    const [ cardZip, setCardZip ] = useState('');
    const [ cardZipComplete, setCardZipComplete ] = useState(false);
    // ACH
    const [ achShown, setAchShown ] = useState(false);
    const [ achActive, setAchActive ] = useState(false);
    const [ bankName, setBankName ] = useState('');
    const [ bankNameComplete, setBankNameComplete ] = useState(false);
    const [ bankContactFirstName, setBankContactFirstName ] = useState('');
    const [ bankContactLastName, setBankContactLastName ] = useState('');
    const [ bankContactFirstNameComplete, setBankContactFirstNameComplete ] = useState(false);
    const [ bankContactLastNameComplete, setBankContactLastNameComplete ] = useState(false);
    const [ bankContactTitle, setBankContactTitle ] = useState('');
    const [ bankContactTitleComplete, setBankContactTitleComplete ] = useState(false);
    const [ bankStreet, setBankStreet ] = useState('');
    const [ bankStreet2, setBankStreet2 ] = useState('');
    const [ bankStreetComplete, setBankStreetComplete ] = useState(false);
    const [ bankCity, setBankCity ] = useState('');
    const [ bankCityComplete, setBankCityComplete ] = useState('');
    const [ bankState, setBankState ] = useState('');
    const [ bankStateComplete, setBankStateComplete ] = useState(false);
    const [ bankZip, setBankZip ] = useState('');
    const [ bankZipComplete, setBankZipComplete ] = useState(false);
    const [ bankCountry, setBankCountry ] = useState('');
    const [ bankCountryComplete, setBankCountryComplete ] = useState(false);
    const [ bankTelephone, setBankTelephone ] = useState('');
    const [ bankTelephoneComplete, setBankTelephoneComplete ] = useState(false);
    const [ bankExtension, setBankExtension ] = useState('');
    const [ bankContactEmail, setBankContactEmail ] = useState('');
    const [ bankContactEmailComplete, setBankContactEmailComplete ] = useState(false);
    const [ bankAccountName, setBankAccountName ] = useState('');
    const [ bankAccountNameComplete, setBankAccountNameComplete ] = useState(false);
    const [ bankAccountNumber, setBankAccountNumber ] = useState('');
    const [ bankAccountNumberComplete, setBankAccountNumberComplete ] = useState(false);
    const [ bankRoutingNumber, setBankRoutingNumber ] = useState('');
    const [ bankRoutingNumberComplete, setBankRoutingNumberComplete ] = useState(false);
    const [ bankSwiftCode, setBankSwiftCode ] = useState('');
    const [ bankSwiftCodeComplete, setBankSwiftCodeComplete ] = useState(false);
    const [ bankAccountSelection, setBankAccountSelection ] = useState('Checking');
    const [ bankAccountSelectionComplete, setBankAccountSelectionComplete ] = useState(false);

    // REQUIRED FILES STATE
    const [ filesActive, setFilesActive] = useState(false);
    const [ filesCompleted, setFilesCompleted ] = useState(false);
    const [ filesRequired, setFilesRequired ] = useState(true);

    const [ taxCertShown, setTaxCertShown ] = useState(false);
    const [ taxCertActive, setTaxCertActive ] = useState(false);
    const [ taxCert, setTaxCert ] = useState();
    const [ taxCertId, setTaxCertId ] = useState();
    const [ taxCertError, setTaxCertError ] = useState('');

    const [ w9Shown, setW9Shown ] = useState(true);
    const [ w9Active, setW9Active ] = useState(true);
    const [ w9, setW9 ] = useState('');
    const [ w9Id, setW9Id ] = useState();
    const [ w9Error, setW9Error ] = useState('');

    const [ intWireShown, setIntWireShown ] = useState(false);
    const [ intWireActive, setIntWireActive ] = useState(false);
    const [ intWire, setIntWire ] = useState();
    const [ intWireId, setIntWireId ] = useState();
    const [ intWireError, setIntWireError ] = useState('');

    const [ voidedCheckShown, setVoidedCheckShown ] = useState(false);
    const [ voidedCheckActive, setVoidedCheckActive ] = useState(false);
    const [ voidedCheckFile, setVoidedCheckFile ] = useState();
    const [ voidedCheckFileId, setVoidedCheckFileId ] = useState();
    const [ voidedCheckError, setVoidedCheckError ] = useState('');

    const [ creditReferenceSheetShown, setCreditReferenceSheetShown ] = useState(false);
    const [ creditReferenceSheetActive, setCreditReferenceSheetActive ] = useState(false);
    const [ creditReferenceSheet, setCreditReferenceSheet ] = useState();
    const [ creditReferenceSheetId, setCreditReferenceSheetId ] = useState();
    const [ creditReferenceSheetError, setCreditReferenceSheetError ] = useState('');

    // CONDITIONS STATE
    const [ conditionsActive, setConditionsActive ] = useState(false);
    const [ conditionsComplete, setConditionsComplete ] = useState(false);
    const [ nameSign, setNameSign ] = useState('');
    const [ nameSignComplete, setNameSignComplete ] = useState(false);
    const [ titleSign, setTitleSign ] = useState('');
    const [ titleSignComplete, setTitleSignComplete ] = useState(false);
    const [ signature, setSignature ] = useState('');
    const [ signatureComplete, setSignatureComplete ] = useState(false);
    const [ date, setDate ]  = useState('');
    const [ dateComplete, setDateComplete ] = useState(false);
    const [ secondarySignature, setSecondarySignature ] = useState(false);
    const [ nameSign2, setNameSign2 ] = useState('');
    const [ nameSign2Complete, setNameSign2Complete ] = useState(false);
    const [ titleSign2, setTitleSign2 ] = useState('');
    const [ titleSign2Complete, setTitleSign2Complete ] = useState(false);
    const [ signature2, setSignature2 ] = useState('');
    const [ signature2Complete, setSignature2Complete ] = useState(false);
    const [ date2, setDate2 ]  = useState('');
    const [ date2Complete, setDate2Complete ] = useState(false);

    // SUBMITTING STATE
    const [ formComplete, setFormComplete] = useState(false);
    const [ submitting, setSubmitting] = useState(false);
    const [ finalizedSubmitting, setFinalizedSubmitted ] = useState(false);
    const [ rejectionRecord, setRejectionRecord ] = useState();
    const [ formSubmissionValid, setFormSubmissionValid] = useState();


    // DEFAULT INITIALIZATION
    useEffect(() => {
        // REJECTION
        const searchParams = params[0];
        if(searchParams.get("sessionId")) grabRejectionRecord(searchParams.get("sessionId"),searchParams.get("rejectionId"),setRejectionRecord);
        else setRejectionRecord(null);

        // NORMAL OPERATIONS AT START
        setDate(getDate('/'));
        setDate2(getDate('/'));
    },[]);

    // REJECTIONS - - - - - - - - - - -
    const markFieldsComplete = (customerProfile) => {
        setFedEinSSnComplete(true);
        setOwnerFirstName1Complete(true);
        setOwnerLastName1Complete(true);
        setLegalNameComplete(true);
        setStreetComplete(true);
        setCityComplete(true);
        setStateComplete(true);
        setZipComplete(true);
        setShippingStreetComplete(true);
        setShippingStateComplete(true);
        setShippingCityComplete(true);
        setShippingZipComplete(true);
        setTaxExemptCertComplete(true);
        setPoRequiredComplete(true);
        setInvoiceCurrencyComplete(true);
        setCustomerClassSelectionComplete(true);
        setPaymentMethodComplete(true);
        setBusinessTypeSelectionComplete(true);
        setStateOfIncComplete(true);
        setPrimaryContactFirstNameComplete(true);
        setPrimaryContactLastNameComplete(true);
        setPrimaryTitleComplete(true);
        setPrimaryContactNumberComplete(true);
        setPrimaryContactEmailComplete(true);
        setContactFirstNameAPComplete(true);
        setContactLastNameAPComplete(true);
        settitleAPComplete(true);
        setPhoneAPComplete(true);
        setContactEmailAPComplete(true);
        setOwnerFirstName1Complete(true);
        setOwnerLastName1Complete(true);
        setTitleComplete(true);
        setEmailAddressComplete(true);
        setPhoneComplete(true);
        setOwnerStreetComplete(true);
        setOwnerCityComplete(true);
        setOwnerStateComplete(true);
        setOwnerZipComplete(true);
        setOwnerFirstName2Complete(true);
        setOwnerLastName2Complete(true);
        setTitle2Complete(true);
        setPhone2Complete(true);
        setOwner2StreetComplete(true);
        setOwner2CityComplete(true);
        setOwner2StateComplete(true);
        setOwner2ZipComplete(true);

        /*
        setContactTradeFirstNameComplete(true);
        setContactTradeLastNameComplete(true);
        setTradeTitleComplete(true);
        setTradeEmailComplete(true);
        setTradePhoneComplete(true);
        setTradeStreetComplete(true);
        setTradeCityComplete(true);
        setTradeStateComplete(true);
        setTradeZipComplete(true);
        setContactTradeFirstName2Complete(true);
        setContactTradeLastName2Complete(true);
        setTradeTitle2Complete(true);
        setTradeEmail2Complete(true);
        setTradePhone2Complete(true);
        setTrade2StreetComplete(true);
        setTrade2CityComplete(true);
        setTrade2StateComplete(true);
        setTrade2ZipComplete(true);
        setContactTradeFirstName3Complete(true);
        setContactTradeLastName3Complete(true);
        setTradeTitle3Complete(true);
        setTradeEmail3Complete(true);
        setTradePhone3Complete(true);
        setTrade3StreetComplete(true);
        setTrade3CityComplete(true);
        setTrade3StateComplete(true);
        setTrade3ZipComplete(true);
        */

        setBankNameComplete(true);
        setBankAccountNameComplete(true);
        setBankStreetComplete(true);
        setBankCityComplete(true);
        setBankStateComplete(true);
        setBankZipComplete(true);
        setBankTelephoneComplete(true);
        setBankContactFirstNameComplete(true);
        setBankContactLastNameComplete(true);
        setBankContactTitleComplete(true);
        setBankContactEmailComplete(true);
        setBankAccountNumberComplete(true);
        setBankRoutingNumberComplete(true);
        setBankSwiftCodeComplete(true);
        setNameSignComplete(true);
        setTitleSignComplete(true);
        setDateComplete(true);
        setNameSign2Complete(true);
        setTitleSign2Complete(true);
    };

    // INITIALIZE FIELDS FOR REJECTION
    const initializeFieldsForRejection = (customerProfile) => {
        console.log(customerProfile);
        //Customer Information
        setFedEinSSn(customerProfile.fedEinSSn);
        setDunsNo(customerProfile.dunsNo);
        setWebsite(customerProfile.website);
        setLegalName(customerProfile.legalName);
        setTradeNameDBA(customerProfile.tradeName);
        setPoRequired(customerProfile.poRequired);
        setPaymentMethod(customerProfile.paymentMethod);
        setBusinessTypeSelection(customerProfile.businessType);
        setStateOfInc(customerProfile.incState);
        setInvoiceCurrency(customerProfile.currency);
        setCustomerClassSelection(customerProfile.class);

        // Business Address
        setStreet(customerProfile.address.street);
        setStreet2(customerProfile.address.street2);
        setCity(customerProfile.address.city);
        setState(customerProfile.address.state);
        setZip(customerProfile.address.zip);
        setCountry(customerProfile.country);
        // Shipping Address
        setShippingStreet(customerProfile.shippingAddress.street);
        setShippingStreet2(customerProfile.shippingAddress.street2);
        setShippingCity(customerProfile.shippingAddress.city);
        setShippingState(customerProfile.shippingAddress.state);
        setShippingZip(customerProfile.shippingAddress.zip);
        setShippingCountry(customerProfile.shippingAddress.country);
        // Tax Exemption
        setTaxExemptCert(customerProfile.taxExempt);
        if(customerProfile.taxExempt === 'Yes'){
            setTaxCertActive(true);
            setTaxCertShown(true);
        }
        else{
            setTaxCertActive(false);
            setTaxCertShown(false);
        };
        
        //Contact Information
        setPrimaryContactFirstName(customerProfile.primaryContact.firstName);
        setPrimaryContactLastName(customerProfile.primaryContact.lastName);
        setPrimaryTitle(customerProfile.primaryContact.title);
        setPrimaryContactEmail(customerProfile.primaryContact.email);
        setPrimaryContactNumber(customerProfile.primaryContact.number);
        setPrimaryExtension(customerProfile.primaryContact.extension);

        console.log(customerProfile)

        //AP Contact
        setContactFirstNameAP(customerProfile.apContact.firstName);
        setContactLastNameAP(customerProfile.apContact.lastName);
        setPhoneAP(customerProfile.apContact.number);
        setExtensionAP(customerProfile.apContact.extension);
        setTitleAP(customerProfile.apContact.title);
        setContactEmailAP(customerProfile.apContact.email);

        //Owners Information
        setFirstName1(customerProfile.authorizedOfficers[0].firstName);
        setLastName1(customerProfile.authorizedOfficers[0].lastName);
        setTitle(customerProfile.authorizedOfficers[0].title);
        setEmailAddress(customerProfile.authorizedOfficers[0].email);
        setPhone(customerProfile.authorizedOfficers[0].number);
        setExtension(customerProfile.authorizedOfficers[0].extension);
        setOwnerStreet(customerProfile.authorizedOfficers[0].address.street);
        setOwnerStreet2(customerProfile.authorizedOfficers[0].address.street2);
        setOwnerCity(customerProfile.authorizedOfficers[0].address.city);
        setOwnerState(customerProfile.authorizedOfficers[0].address.state);
        setOwnerZip(customerProfile.authorizedOfficers[0].address.zip);
        setOwnerCountry(customerProfile.authorizedOfficers[0].address.country);
        if(customerProfile.authorizedOfficers[1]){
            setSecondaryOwner(true);
            setFirstName2(customerProfile.authorizedOfficers[1].firstName);
            setLastName2(customerProfile.authorizedOfficers[1].lastName);
            setTitle2(customerProfile.authorizedOfficers[1].title);
            setEmailAddress2(customerProfile.authorizedOfficers[1].email);
            setPhone2(customerProfile.authorizedOfficers[1].number);
            setExtension2(customerProfile.authorizedOfficers[1].extension);
            setOwner2Street(customerProfile.authorizedOfficers[1].address.street);
            setOwner2Street2(customerProfile.authorizedOfficers[1].address.street2);
            setOwner2City(customerProfile.authorizedOfficers[1].address.city);
            setOwner2State(customerProfile.authorizedOfficers[1].address.state);
            setOwner2Zip(customerProfile.authorizedOfficers[1].address.zip);
            setOwner2Country(customerProfile.authorizedOfficers[1].address.country);
        };
        
        //Trade References
        if(customerProfile.tradeReferences && customerProfile.tradeReferences[0]){
            setCompanyName(customerProfile.tradeReferences[0].company);
            setContactFirstName(customerProfile.tradeReferences[0].firstName);
            setContactLastName(customerProfile.tradeReferences[0].lastName);
            setTradeTitle(customerProfile.tradeReferences[0].title);
            setTradeEmail(customerProfile.tradeReferences[0].email);
            setTradePhone(customerProfile.tradeReferences[0].number);
            setTradeExtension(customerProfile.tradeReferences[0].extension);
            setTradeStreet(customerProfile.tradeReferences[0].address.street);
            setTradeStreet2(customerProfile.tradeReferences[0].address.street2);
            setTradeCity(customerProfile.tradeReferences[0].address.city);
            setTradeState(customerProfile.tradeReferences[0].address.state);
            setTradeZip(customerProfile.tradeReferences[0].address.zip);
            setTradeCountry(customerProfile.tradeReferences[0].address.country);
        };
        if(customerProfile.tradeReferences && customerProfile.tradeReferences[1]){
            setSecondaryReference(true);
            setCompanyName2(customerProfile.tradeReferences[1].company);
            setContactFirstName2(customerProfile.tradeReferences[1].firstName);
            setContactLastName2(customerProfile.tradeReferences[1].lastName);
            setTradeTitle2(customerProfile.tradeReferences[1].title);
            setTradeEmail2(customerProfile.tradeReferences[1].email);
            setTradePhone2(customerProfile.tradeReferences[1].number);
            setTradeExtension2(customerProfile.tradeReferences[1].extension);
            setTrade2Street(customerProfile.tradeReferences[1].address.street);
            setTrade2Street2(customerProfile.tradeReferences[1].address.street2);
            setTrade2City(customerProfile.tradeReferences[1].address.city);
            setTrade2State(customerProfile.tradeReferences[1].address.state);
            setTrade2Zip(customerProfile.tradeReferences[1].address.zip);
            setTrade2Country(customerProfile.tradeReferences[1].address.country);
        };
        if(customerProfile.tradeReferences && customerProfile.tradeReferences[2]){
            setThirdReference(true);
            setCompanyName3(customerProfile.tradeReferences[2].company);
            setContactFirstName3(customerProfile.tradeReferences[2].firstName);
            setContactLastName3(customerProfile.tradeReferences[2].lastName);
            setTradeTitle3(customerProfile.tradeReferences[2].title);
            setTradeEmail3(customerProfile.tradeReferences[2].email);
            setTradePhone3(customerProfile.tradeReferences[2].number);
            setTradeExtension3(customerProfile.tradeReferences[2].extension);
            setTrade3Street(customerProfile.tradeReferences[2].address.street);
            setTrade3Street2(customerProfile.tradeReferences[2].address.street2);
            setTrade3City(customerProfile.tradeReferences[2].address.city);
            setTrade3State(customerProfile.tradeReferences[2].address.state);
            setTrade3Zip(customerProfile.tradeReferences[2].address.zip);
            setTrade3Country(customerProfile.tradeReferences[2].address.country);
        };

        //ACH 
        if(customerProfile.bankAccount){
            setBankName(customerProfile.bankAccount.name);
            setBankContactFirstName(customerProfile.bankAccount.contact.firstName);
            setBankContactLastName(customerProfile.bankAccount.contact.lastName);
            setBankStreet(customerProfile.bankAccount.address.street);
            setBankStreet2(customerProfile.bankAccount.address.street2);
            setBankCity(customerProfile.bankAccount.address.city);
            setBankState(customerProfile.bankAccount.address.state);
            setBankZip(customerProfile.bankAccount.address.zip);
            setBankCountry(customerProfile.bankAccount.address.country);
            setBankTelephone(customerProfile.bankAccount.contact.number);
            setBankExtension(customerProfile.bankAccount.contact.extension);
            setBankContactTitle(customerProfile.bankAccount.contact.title);
            setBankContactEmail(customerProfile.bankAccount.contact.email);
            setBankAccountName(customerProfile.bankAccount.accountName);
            setBankAccountNumber(customerProfile.bankAccount.accountNumber);
            setBankRoutingNumber(customerProfile.bankAccount.routingNumber);
            setBankSwiftCode(customerProfile.bankAccount.swiftCode);
            setBankAccountSelection(customerProfile.bankAccount.accountType);
        };
        if(customerProfile.paymentMethod === 'ACH'){
            //setVoidedCheckActive(true);
            //setVoidedCheckShown(true);
            //setAchShown(true);
        }
        else{
            //setVoidedCheckActive(false);
            //setVoidedCheckShown(false);
            //setAchShown(false);
        }

        // CREDIT REFERENCE SHEET
        if(customerProfile.businessType !== 'Government'){
            setCreditReferenceSheetActive(true);
            setCreditReferenceSheetShown(true);
        }
        else{
            setCreditReferenceSheetActive(false);
            setCreditReferenceSheetShown(false);
        };

        setNameSign(customerProfile.signer1Name);
        setTitleSign(customerProfile.signer1Title);

        if(customerProfile.secondarySignature){
            setNameSign2(customerProfile.signer2Name);
            setTitleSign2(customerProfile.signer2Title);
        };
    };

    // CHECK FOR REJECTION RECORD AND CALL TO INITIALIZE
    useEffect(() => {
        if(rejectionRecord){
        initializeFieldsForRejection(rejectionRecord.customerProfile);
        markFieldsComplete(rejectionRecord.customerProfile);
        };
    },[rejectionRecord]);

    useEffect(() => { // DETERMINES IF THIS IS A REJECTION OR NOT
        const searchParams = params[0];
        if(searchParams.get("sessionId")) grabRejectionRecord(searchParams.get("sessionId"),searchParams.get("rejectionId"),setRejectionRecord);
        else setRejectionRecord(null);
    },[]);

    //Rejection Prop
    const rejectionProps = {
        rejectionRecord: rejectionRecord,
    };

    // SHOW ACH, INTERNATIONAL WIRE, & CREDIT CARD WHEN REQUIRED
    useEffect(() => {
        if(paymentMethod === 'ACH'){
            //setAchShown(true);
            //setAchActive(true);
            //setVoidedCheckShown(true);
            //setVoidedCheckActive(true);
        }
        else{
            //setAchShown(false);
            //setAchActive(false);
            //setVoidedCheckShown(false);
            //setVoidedCheckActive(false);
        };

        if(paymentMethod === 'Wire'){
            //setIntWireActive(true);
            //setIntWireShown(true);
        }
        else{
            //setIntWireActive(false);
            //setIntWireShown(false);
        };

    },[paymentMethod]);

    // SHOW TAX CERTIFICATE
    useEffect(() => {
        if(taxExemptCert === 'Yes'){    
            setTaxCertActive(true);
            setTaxCertShown(true);
        }
        else{
            setTaxCertActive(false);
            setTaxCertShown(false);
        };
    },[taxExemptCert]);    

    // SHOW CREDIT REFERENCE SHEET
    useEffect(() => {    
        if(businessTypeSelection !== 'Government'){
            setCreditReferenceSheetActive(true);
            setCreditReferenceSheetShown(true);
        }
        else{
            setCreditReferenceSheetActive(false);
            setCreditReferenceSheetShown(false);
        };
    },[businessTypeSelection]); 

    // - - - - - INPUT / COMPLETE CHECK - - - - - - - -
    //  CUSTOMER INFORMATION
    const checkCustomerInformationFields = () => {
        let complete = true;

        if(fedEinSSn.length === 9){
            setFedEinSSnComplete(true);
        }
        else{
            setFedEinSSnComplete(false)
            complete = false;
        };
        
        if(dunsNo){
            if(dunsNo.length === 9) {
                setdunsNoComplete(true);
            }
            else{
                setdunsNoComplete(false);
            };
        };
        
        if(legalName.length > 3){
            setLegalNameComplete(true); 
        } 
        else{
            setLegalNameComplete(false);
            complete = false;

        };   
        
        if(tradeNameDBA){
            if(tradeNameDBA.length > 2) {
                setTradeNameDBAComplete(true);
            }
            else{
                setTradeNameDBAComplete(false)
                //complete = false;
            };
        };

        if(street.length > 2) {
            setStreetComplete(true);
        }
        else{
            setStreetComplete(false)
            complete = false;
        };
        
        if(shippingStreet.length > 2) {
            setShippingStreetComplete(true);
        }
        else{
            setShippingStreetComplete(false)
            complete = false;
        };
        
        if(city.length > 2) {
            setCityComplete(true);
        }
        else{
            setCityComplete(false)
            complete = false;
        };
        
        if(shippingCity.length > 2) {
            setShippingCityComplete(true);
        }
        else{
            setShippingCityComplete(false)
            complete = false;
        };
        
        if(state.length > 1) {
            setStateComplete(true);
        }
        else{
            setStateComplete(false)
            complete = false;
        };
        
        if(shippingState.length > 1) {
            setShippingStateComplete(true);
        }
        else{
            setShippingStateComplete(false)
            complete = false;
        };
        
        if(zip.length >= 5){
            setZipComplete(true);
        }
        else{
            setZipComplete(false)
            complete = false;
        };
        
        if(shippingZip.length >= 5){
            setShippingZipComplete(true);
        }
        else{
            setShippingZipComplete(false)
            complete = false;
        };

        if(taxExemptCert){
            setTaxExemptCertComplete(true);
        }
        else{
            setTaxExemptCertComplete(false);
            complete = false;
        };

        if(poRequired)setPoRequiredComplete(true);
        else{
            setPoRequiredComplete(false);
            complete = false;
        };

        if(invoiceCurrency) setInvoiceCurrencyComplete(true);
        else {
            setInvoiceCurrencyComplete(false);
            complete = false;
        };

        if(customerClassSelection){
            setCustomerClassSelectionComplete(true);
        }
        else{
            setCustomerClassSelectionComplete(false);
            complete = false;
        };

        if(stateOfInc.length == 2){
            setStateOfIncComplete(true);
        }
        else{
            setStateOfIncComplete(false);
            complete = false;
        };

        if(paymentMethod){
            setPaymentMethodComplete(true);
        }
        else{
            setPaymentMethodComplete(false);
            complete = false;
        };

        if(businessTypeSelection){
            setBusinessTypeSelectionComplete(true);
        }
        else{
            setBusinessTypeSelectionComplete(false);
            complete = false;
        };
            
        return complete;
    };
    useEffect(() => {
            if(checkCustomerInformationFields()){
                setCustomerInformationComplete(true);
                setCustomerInformationActive(false);
            }
            else{
                setCustomerInformationComplete(false);
                setCustomerInformationActive(true);
            };
    },[fedEinSSn,dunsNo,legalName,tradeNameDBA,street,street2,city,state,zip,shippingStreet,shippingCity,shippingState,shippingZip,
        stateOfInc,paymentMethod,businessTypeSelection,taxExemptCert,poRequired,invoiceCurrency]);

    //  PRIMARY & AP INFORMATION
    const checkPrimaryContactAndAPFields = () => {
        let complete = true;

        if(primaryContactFirstName.length > 2) setPrimaryContactFirstNameComplete(true);
        else{
            setPrimaryContactFirstNameComplete(false);
            complete = false;
        };

        if(primaryContactLastName.length > 2) setPrimaryContactLastNameComplete(true);
        else{
            setPrimaryContactLastNameComplete(false);
            complete = false;
        };
        
        if(primaryContactNumber.length === 10){
            setPrimaryContactNumberComplete(true);
        }
        else{
            setPrimaryContactNumberComplete(false);
            complete = false;
        };
        
        if(primaryTitle.length > 2){
            setPrimaryTitleComplete(true);
        }
        else{
            setPrimaryTitleComplete(false);
            complete = false;
        };
        /*
        if(primaryStreet.length > 2) {
            setPrimaryStreetComplete(true);
        }
        else{
            setPrimaryStreetComplete(false)
            complete = false;
        };
        
        if(primaryCity.length > 2) {
            setPrimaryCityComplete(true);
        }
        else{
            setPrimaryCityComplete(false)
            complete = false;
        };
        
        if(primaryState.length > 1) {
            setPrimaryStateComplete(true);
        }
        else{
            setPrimaryStateComplete(false)
            complete = false;
        };

        if(primaryZip.length === 5) {
            setPrimaryZipComplete(true);
        }
        else{
            setPrimaryZipComplete(false)
            complete = false;
        };
        */
        if(checkEmail(primaryContactEmail)) setPrimaryContactEmailComplete(true);
        else{
            setPrimaryContactEmailComplete(false);
            complete = false;
        };

        if(contactFirstNameAP.length > 2){
            setContactFirstNameAPComplete(true);
        }
        else{
            setContactFirstNameAPComplete(false);
            complete = false;
        };

        if(contactLastNameAP.length > 2){
            setContactLastNameAPComplete(true);
        }
        else{
            setContactLastNameAPComplete(false);
            complete = false;
        };

        if(titleAP.length > 2){
            settitleAPComplete(true);
        }
        else{
            settitleAPComplete(false);
            complete = false;
        };

        if(phoneAP.length === 10){
            setPhoneAPComplete(true);
        }
        else{
            setPhoneAPComplete(false);
            complete = false;
        };

        if(checkEmail(contactEmailAP)) setContactEmailAPComplete(true);
        else{
            setContactEmailAPComplete(false);
            complete = false;
        };

        return complete;
    };
    useEffect(() => {
            if(checkPrimaryContactAndAPFields()){
                setPrimaryAndAPComplete(true);
                setPrimaryContactAndApActive(false);
            }
            else{
                setPrimaryAndAPComplete(false);
                setPrimaryContactAndApActive(true);
            };
    },[primaryContactFirstName,primaryContactLastName,primaryContactNumber,primaryTitle,primaryContactEmail,primaryStreet,primaryCity,
        primaryState,primaryZip,contactFirstNameAP,contactLastNameAP,titleAP,phoneAP,contactEmailAP]);

    //  OWNERS INFORMATION
    const checkOwnersInformationFields= () => {
        let complete = true;

        if(firstName1.length > 2){
            setOwnerFirstName1Complete(true);   
        } 
        else{
            setOwnerFirstName1Complete(false);
            complete = false;
        };

        if(lastName1.length > 2){
            setOwnerLastName1Complete(true);   
        } 
        else{
            setOwnerLastName1Complete(false);
            complete = false;
        };

        if(title.length > 2){
            setTitleComplete(true);
        }
        else{
            setTitleComplete(false);
            complete = false;
        };

        if(phone.length === 10){
            setPhoneComplete(true);
        }
        else{
            setPhoneComplete(false);
            complete = false;
        };

        if(ownerStreet.length > 2) {
            setOwnerStreetComplete(true);
        }
        else{
            setOwnerStreetComplete(false)
            complete = false;
        };

        if(ownerCity.length > 2) {
            setOwnerCityComplete(true);
        }
        else{
            setOwnerCityComplete(false)
            complete = false;
        };

        if(ownerState.length > 1) {
            setOwnerStateComplete(true);
        }
        else{
            setOwnerStateComplete(false)
            complete = false;
        };

        if(ownerZip.length >= 5) {
            setOwnerZipComplete(true);
        }
        else{
            setOwnerZipComplete(false)
            complete = false;
        };

        if(checkEmail(emailAddress)) setEmailAddressComplete(true);
        else{
            setEmailAddressComplete(false);
            complete = false;
        };

        if(secondaryOwner){
            if(firstName2.length > 2) setOwnerFirstName2Complete(true);
            else{
                setOwnerFirstName2Complete(false);
                complete = false;
            };

            if(lastName2.length > 2) setOwnerLastName2Complete(true);
            else{
                setOwnerLastName2Complete(false);
                complete = false;
            };
    
            if(title2.length > 2){
                setTitle2Complete(true);
            }
            else{
                setTitle2Complete(false);
                complete = false;
            };

            if(phone2.length === 10){
                setPhone2Complete(true);
            }
            else{
                setPhone2Complete(false);
                complete = false;
            };
    
            if(owner2Street.length > 2) {
                setOwner2StreetComplete(true);
            }
            else{
                setOwner2StreetComplete(false)
                complete = false;
            };
    
            if(owner2City.length > 2) {
                setOwner2CityComplete(true);
            }
            else{
                setOwner2CityComplete(false)
                complete = false;
            };
    
            if(owner2State.length > 1) {
                setOwner2StateComplete(true);
            }
            else{
                setOwner2StateComplete(false)
                complete = false;
            };
    
            if(owner2Zip.length >= 5) {
                setOwner2ZipComplete(true);
            }
            else{
                setOwner2ZipComplete(false)
                complete = false;
            };
    
            if(checkEmail(emailAddress2)) setEmailAddress2Complete(true);
            else{
                setEmailAddress2Complete(false);
                complete = false;
            };
        };

        return complete;
    };
    useEffect(() => {
            if(checkOwnersInformationFields()){
                setOwnersOrOfficersInformationComplete(true);
                setOwnersOrOfficersInformationActive(false);
            }
            else{
                setOwnersOrOfficersInformationComplete(false);
                setOwnersOrOfficersInformationActive(true);
            };
    },[firstName1,lastName1,title,phone,ownerStreet,ownerCity,ownerState,ownerZip,emailAddress,firstName2,lastName2,title2,phone2,
        owner2Street,owner2City,owner2State,owner2Zip,emailAddress2, secondaryOwner]);

    //  TRADE REFERENCE INFORMATION
    const checkTradeInformationFields = () => {
        let complete = true;
    
        if(companyName.length > 2){
            setCompanyNameComplete(true);
            if(contactFirstName.length > 2) setContactTradeFirstNameComplete(true);
            else{
                setContactTradeFirstNameComplete(false);
                complete = false;
            };
    
            if(contactLastName.length > 2) setContactTradeLastNameComplete(true);
            else{
                setContactTradeLastNameComplete(false);
                complete = false;
            };
    
            if(tradeTitle.length > 2){
                setTradeTitleComplete(true);
            }
            else{
                setTradeTitleComplete(false);
                complete = false;
            }
    
            if(checkEmail(tradeEmail)) setTradeEmailComplete(true);
                else{
                    setTradeEmailComplete(false);
                    complete = false;
                };
    
            if(tradePhone.length === 10){
                setTradePhoneComplete(true);
            }
            else{
                setTradePhoneComplete(false);
                complete = false;
            };  
    
            if(tradeStreet.length > 3) {
                setTradeStreetComplete(true);
            }
            else{
                setTradeStreetComplete(false)
                complete = false;
            };
    
            if(tradeCity.length > 2) {
                setTradeCityComplete(true);
            }
            else{
                setTradeCityComplete(false)
                complete = false;
            };
    
            if(tradeState.length > 1) {
                setTradeStateComplete(true);
            }
            else{
                setTradeStateComplete(false)
                complete = false;
            };
    
            if(tradeZip.length >= 5) {
                setTradeZipComplete(true);
            }
            else{
                setTradeZipComplete(false)
                complete = false;
            };
        }
        else{
            setCompanyNameComplete(false);
            //complete = false;
        };

        if(secondaryReference){
            if(companyName2.length > 2){
                setCompanyName2Complete(true);
            }
            else{
                setCompanyName2Complete(false);
                complete = false;
            };
    
            if(contactFirstName2.length > 3) setContactTradeFirstName2Complete(true);
            else{
                setContactTradeFirstName2Complete(false);
                complete = false;
            };

            if(contactLastName2.length > 3) setContactTradeLastName2Complete(true);
            else{
                setContactTradeLastName2Complete(false);
                complete = false;
            };

            if(tradeTitle2.length > 2){
                setTradeTitle2Complete(true);
            }
            else{
                setTradeTitle2Complete(false);
                complete = false;
            }
    
            if(checkEmail(tradeEmail2)) setTradeEmail2Complete(true);
                else{
                    setTradeEmail2Complete(false);
                    complete = false;
                };
    
            if(tradePhone2.length === 10){
                setTradePhone2Complete(true);
            }
            else{
                setTradePhone2Complete(false);
                complete = false;
            };

            if(trade2Street.length > 3) {
                setTrade2StreetComplete(true);
            }
            else{
                setTrade2StreetComplete(false)
                complete = false;
            };
    
            if(trade2City.length > 2) {
                setTrade2CityComplete(true);
            }
            else{
                setTrade2CityComplete(false)
                complete = false;
            };
    
            if(trade2State.length > 1) {
                setTrade2StateComplete(true);
            }
            else{
                setTrade2StateComplete(false)
                complete = false;
            };
    
            if(trade2Zip.length >= 5) {
                setTrade2ZipComplete(true);
            }
            else{
                setTrade2ZipComplete(false)
                complete = false;
            };
        };

        if(thirdReference){
            if(companyName3.length > 2){
                setCompanyName3Complete(true);
            }
            else{
                setCompanyName3Complete(false);
                complete = false;
            };
    
            if(contactFirstName3.length > 2){
                setContactTradeFirstName3Complete(true);
            } 
            else{
                setContactTradeFirstName3Complete(false);
                complete = false;
            };

            if(contactLastName3.length > 2){
                setContactTradeLastName3Complete(true);
            } 
            else{
                setContactTradeLastName3Complete(false);
                complete = false;
            };

            if(tradeTitle3.length > 2){
                setTradeTitle3Complete(true);
            }
            else{
                setTradeTitle3Complete(false);
                complete = false;
            }
    
            if(checkEmail(tradeEmail3)) setTradeEmail3Complete(true);
                else{
                    setTradeEmail3Complete(false);
                    complete = false;
                };
    
            if(tradePhone3.length === 10){
                setTradePhone3Complete(true);
            }
            else{
                setTradePhone3Complete(false);
                complete = false;
            };  

            if(trade3Street.length > 2) {
                setTrade3StreetComplete(true);
            }
            else{
                setTrade3StreetComplete(false)
                complete = false;
            };
    
            if(trade3City.length > 2) {
                setTrade3CityComplete(true);
            }
            else{
                setTrade3CityComplete(false)
                complete = false;
            };
    
            if(trade3State.length > 1) {
                setTrade3StateComplete(true);
            }
            else{
                setTrade3StateComplete(false)
                complete = false;
            };
    
            if(trade3Zip.length >= 5) {
                setTrade3ZipComplete(true);
            }
            else{
                setTrade3ZipComplete(false)
                complete = false;
            };
        };
        
        return complete;
    
};
    useEffect(() => {
            if(checkTradeInformationFields()){
                setTradeReferencesInformationComplete(true);
                setTradeReferencesInformationActive(false);
            }
            else{
                setTradeReferencesInformationComplete(false);
                setTradeReferencesInformationActive(true);
            };
    },[companyName,contactFirstName,contactLastName,tradeTitle,tradeEmail,tradePhone,tradeStreet,tradeCity,tradeState,tradeZip,companyName2,contactFirstName2,
        contactLastName2,tradeTitle2,tradeEmail2,tradePhone2,trade2Street,trade2City,trade2State,trade2Zip,companyName3,contactFirstName3,contactLastName3,
        tradeTitle3,tradeEmail3,tradePhone3,trade3Street,trade3City,trade3State,trade3Zip,secondaryReference,thirdReference]);

    //  PAYMENT INFORMATION
    const checkACHInformationFields = () => {
        let complete = true;

        if(achActive){
            if(bankName.length > 2) setBankNameComplete(true);
            else{
                setBankNameComplete(false);
                complete = false;
            };
    
            if(bankContactFirstName.length > 2) setBankContactFirstNameComplete(true);
            else{
                setBankContactFirstNameComplete(false);
                complete = false;
            };
    
            if(bankContactLastName.length > 2) setBankContactLastNameComplete(true);
            else{
                setBankContactLastNameComplete(false);
                complete = false;
            };
    
            if(bankContactTitle.length > 2){
                setBankContactTitleComplete(true);
            }
            else{
                setBankContactTitleComplete(false);
                complete = false;
            }
    
            if(bankStreet.length > 2) setBankStreetComplete(true);
            else{
                setBankStreetComplete(false);
                complete = false;
            };
    
            if(bankCity.length > 2) setBankCityComplete(true);
            else{
                setBankCityComplete(false);
                complete = false;
            };
    
            if(bankState.length > 1) setBankStateComplete(true);
            else{
                setBankStateComplete(false);
                complete = false;
            };
    
            if(bankZip.length >= 5) setBankZipComplete(true);
            else{
                setBankZipComplete(false);
                complete = false;
            };
    
            if(bankTelephone.length === 10) setBankTelephoneComplete(true);
            else{
                setBankTelephoneComplete(false);
                complete = false;
            };
            
            if(checkEmail(bankContactEmail)) setBankContactEmailComplete(true);
            else{
                setBankContactEmailComplete(false);
                complete = false;
            };
    
            if(bankAccountName.length > 2) setBankAccountNameComplete(true);
            else{
                setBankAccountNameComplete(false);
                complete = false;
            };
    
            if(bankAccountNumber.length > 7) setBankAccountNumberComplete(true);
            else{
                setBankAccountNumberComplete(false);
                complete = false;
            };
    
            if(bankRoutingNumber.length === 9) setBankRoutingNumberComplete(true);
            else{
                setBankRoutingNumberComplete(false);
                complete = false;
            };
    
            if(bankAccountSelection && bankAccountSelection !== '') setBankAccountSelectionComplete(true);
            else{
                setBankAccountSelectionComplete(false);
                complete = false;
            };
        };

        return complete;
    };
    const checkCreditCardInformationFields = () => {
        let complete = true;
        
        if(creditCardActive){
            if(nameOnCard.length > 2) {
                setNameOnCardComplete(true);
            }
            else{
                setNameOnCardComplete(false);
                complete = false;
            };
        

            if(cardNumber.length >= 15){
                setCardNumberComplete(true);
            }
            else{
                setCardNumberComplete(false);
                complete = false;
            };

            if(expDate.length > 3){
                setExpDateComplete(true);
            }
            else{
                setExpDateComplete(false);
                complete = false;
            };

            if(cvv.length > 2){
                setCvvComplete(true);
            }
            else{
                setCvvComplete(false);
                complete = false;
            };

            if(cardZip.length === 5){
                setCardZipComplete(true);
            }
            else{
                setCardZipComplete(false);
                complete = false;
            };
        };

        return complete;
    };
    useEffect(() => {
            if(checkACHInformationFields()){
                setAchActive(false);
            }
            else{
                setAchActive(true);
            };

            if(checkCreditCardInformationFields()){
                setCreditCardComplete(true);
                setCreditCardActive(false);
            }
            else{
                setCreditCardComplete(false);
                setCreditCardActive(true);
            }

            if(checkACHInformationFields() && checkCreditCardInformationFields()) setPaymentInformationComplete(true);
            else setPaymentInformationComplete(false);


    },[tradeReferencesInformationComplete,nameOnCard,cardNumber,expDate,cvv,cardZip,bankName,bankContactFirstName,bankContactLastName,
        bankContactTitle,bankStreet,bankCity,bankState,bankZip,bankTelephone,bankContactEmail,bankAccountName,bankAccountNumber,
        bankRoutingNumber,bankSwiftCode,bankAccountSelection]);

    //  FILES INFORMATION
    const checkFiles = () => {
        let complete = true;

        if(!rejectionRecord){
            if(w9Active && !w9) complete = false;
            if(intWireActive && !intWire) complete = false;
            if(voidedCheckActive && !voidedCheckFile) complete = false;
            if(creditReferenceSheetActive && !creditReferenceSheet) complete = false;
        }
        else{
            if(w9Active && (!w9 && !rejectionRecord.customerProfile.w9)) complete = false;
            if(intWireActive && (!intWire && !rejectionRecord.customerProfile.internationalWire)) complete = false;
            if(voidedCheckActive && (!voidedCheckFile && !rejectionRecord.customerProfile.voidedCheck)) complete = false;
            if(creditReferenceSheetActive && (!creditReferenceSheet && !rejectionRecord.customerProfile.creditSheet)) complete = false;
        };

        return complete;
    };
    useEffect(() => {
            if(checkFiles()){
                setFilesCompleted(true);
                setFilesActive(false);
            }
            else{
                setFilesCompleted(false);
                setFilesActive(true);
            };
    },[taxCertActive,taxCert,w9Active,w9,intWireActive,intWire,voidedCheckActive,voidedCheckFile,creditReferenceSheetActive,creditReferenceSheet,rejectionRecord]);

    //  CONDITIONS INFORMATION
    const checkConditionsComplete = () => {
        let complete = true;

        if(signature.length > 2) setSignatureComplete(true);
        else{
            setSignatureComplete(false);
            complete = false;
        };

        if(nameSign.length > 2) {
            setNameSignComplete(true);
        }
        else{
            setNameSignComplete(false);
            complete = false;
        };

        if(titleSign.length > 2) {
            setTitleSignComplete(true);
        }
        else{
            setTitleSignComplete(false);
            complete = false;
        };

        
        if(date.length > 2) {
            setDateComplete(true);
        }
        else{
            setDateComplete(false);
            complete = false;
        };

        if(secondarySignature) {
            if(nameSign2.length > 2){
                setNameSign2Complete(true);  
            } 
            else{
                setNameSign2Complete(false);
                complete = false;
            };
            
            if(titleSign2.length > 2) {
                setTitleSign2Complete(true);
            }
            else{
                setTitleSign2Complete(false);
                complete = false;
            };

            if(signature2.length > 2) setSignature2Complete(true);
            else{
                setSignature2Complete(false);
                complete = false;
            };
            if(date2.length > 2){
                setDate2Complete(true);
            }
            else{
                setDate2Complete(false);
                complete = false;
            };
        };

        return complete;
    };
    useEffect(() => {
        //if(!rejectionRecord){
            if(checkConditionsComplete()){
                setConditionsActive(false);
                setConditionsComplete(true);
            }
            else{
                setConditionsActive(true);
                setConditionsComplete(false);
            };
        //};
    },[nameSign,titleSign,signature,date,nameSign2,titleSign2,signature2,date2]);

    //  COMPLETE FORM
    const checkFormFields = () => {
        let complete = true;

        if(!customerInformationComplete) complete = false;
        if(!primaryAndAPComplete) complete = false;
        if(!ownersOrOfficersInformationComplete) complete = false;
        if(!tradeReferencesInformationComplete) complete = false;
        if(!paymentInformationComplete) complete = false;
        if(!filesCompleted) complete = false;
        if(!conditionsComplete) complete = false;
             
        return complete;
    };
    useEffect(() => {
        setFormComplete(checkFormFields());
    },[customerInformationComplete,primaryAndAPComplete,ownersOrOfficersInformationComplete,tradeReferencesInformationComplete,secondaryReference,thirdReference,
        paymentInformationComplete,filesCompleted,conditionsComplete]);
    // PROPS
    const customerInformationProps = {
        customerInformationActive:customerInformationActive,
        setFedEinSSn:setFedEinSSn,
        fedEinSSn:fedEinSSn,
        fedEinSSnComplete,fedEinSSnComplete,
        setDunsNo:setDunsNo,
        dunsNo:dunsNo,
        dunsNoComplete:dunsNoComplete,
        setWebsite:setWebsite,
        website:website,
        websiteComplete:websiteComplete,
        setLegalName:setLegalName,
        legalName:legalName,
        legalNameComplete:legalNameComplete,
        setTradeNameDBA:setTradeNameDBA,
        tradeNameDBA:tradeNameDBA,
        tradeNameDBAComplete:tradeNameDBAComplete,
        setStreet:setStreet,
        street:street,
        street2:street2,
        setStreet2:setStreet2,
        streetComplete:streetComplete,
        setCity:setCity,
        city:city,
        cityComplete:cityComplete,
        setState:setState,
        state:state,
        stateComplete:stateComplete,
        setZip:setZip,
        zip:zip,
        zipComplete:zipComplete,
        setCountry:setCountry,
        country:country,
        setShippingStreet:setShippingStreet,
        shippingStreet:shippingStreet,
        shippingStreet2:shippingStreet2,
        setShippingStreet2:setShippingStreet2,
        shippingStreetComplete:shippingStreetComplete,
        setShippingCity:setShippingCity,
        shippingCity:shippingCity,
        shippingCityComplete:shippingCityComplete,
        setShippingState:setShippingState,
        shippingState:shippingState,
        shippingStateComplete:shippingStateComplete,
        setShippingZip:setShippingZip,
        shippingZip:shippingZip,
        shippingZipComplete:shippingZipComplete,
        setShippingCountry:setShippingCountry,
        shippingCountry:shippingCountry,
        taxExemptOptions:taxExemptOptions,
        poOptions:poOptions,
        setTaxExemptCert:setTaxExemptCert,
        taxExemptCert:taxExemptCert,
        taxExemptCertComplete:taxExemptCertComplete,
        paymentOptions:paymentOptions,
        setPaymentMethod:setPaymentMethod,
        paymentMethod:paymentMethod,
        paymentMethodComplete:paymentMethodComplete,
        businessTypeOptions:businessTypeOptions,
        setBusinessTypeSelection:setBusinessTypeSelection,
        businessTypeSelection:businessTypeSelection,
        businessTypeSelectionComplete:businessTypeSelectionComplete,
        setStateOfInc:setStateOfInc,
        stateOfInc:stateOfInc,
        stateOfIncComplete:stateOfIncComplete,
        poRequired:poRequired,
        setPoRequired:setPoRequired,
        poRequiredComplete:poRequiredComplete,
        customerClassOptions:customerClassOptions,
        setCustomerClassSelection:setCustomerClassSelection,
        customerClassSelection:customerClassSelection,
        customerClassSelectionComplete:customerClassSelectionComplete
    };

    const primaryAndAPProps = {
        primaryContactAndApActive:primaryContactAndApActive,
        setPrimaryContactFirstName:setPrimaryContactFirstName,
        primaryContactFirstName:primaryContactFirstName,
        setPrimaryContactLastName:setPrimaryContactLastName,
        primaryContactLastName:primaryContactLastName,
        primaryContactFirstNameComplete:primaryContactFirstNameComplete,
        primaryContactLastNameComplete:primaryContactLastNameComplete,
        setPrimaryContactNumber:setPrimaryContactNumber,
        primaryContactNumber:primaryContactNumber,
        primaryContactNumberComplete:primaryContactNumberComplete,
        setPrimaryExtension:setPrimaryExtension,
        primaryExtension:primaryExtension,
        setPrimaryTitle:setPrimaryTitle,
        primaryTitle:primaryTitle,
        primaryTitleComplete:primaryTitleComplete,
        setPrimaryContactEmail:setPrimaryContactEmail,
        primaryContactEmail:primaryContactEmail,
        primaryContactEmailComplete:primaryContactEmailComplete,
        setPrimaryStreet:setPrimaryStreet,
        primaryStreet:primaryStreet,
        primaryStreetComplete:primaryStreetComplete,
        setPrimaryStreet2:setPrimaryStreet2,
        primaryStreet2:primaryStreet2,
        setPrimaryCity:setPrimaryCity,
        primaryCity:primaryCity,
        primaryCityComplete:primaryCityComplete,
        setPrimaryState:setPrimaryState,
        primaryState:primaryState,
        primaryStateComplete:primaryStateComplete,
        setPrimaryZip:setPrimaryZip,
        primaryZip:primaryZip,
        primaryZipComplete:primaryZipComplete,
        setPrimaryCountry:setPrimaryCountry,
        primaryCountry:primaryCountry,

        contactFirstNameAP:contactFirstNameAP,
        setContactFirstNameAP:setContactFirstNameAP,
        contactLastNameAP:contactLastNameAP,
        setContactLastNameAP:setContactLastNameAP,
        contactFirstNameAPComplete:contactFirstNameAPComplete,
        contactLastNameAPComplete:contactLastNameAPComplete,
        titleAP:titleAP,
        setTitleAP:setTitleAP,
        titleAPComplete:titleAPComplete,
        setPhoneAP:setPhoneAP,
        phoneAP:phoneAP,
        phoneAPComplete:phoneAPComplete,
        extensionAP:extensionAP,
        setExtensionAP:setExtensionAP,
        setContactEmailAP:setContactEmailAP,
        contactEmailAP:contactEmailAP,
        contactEmailAPComplete:contactEmailAPComplete,
    };

    const OwnersOrOfficersInformationProps = {
        ownersOrOfficersInformationActive:ownersOrOfficersInformationActive,
        setFirstName1:setFirstName1,
        firstName1:firstName1,
        setLastName1:setLastName1,
        lastName1:lastName1,
        ownerFirstName1Complete:ownerFirstName1Complete,
        ownerLastName1Complete:ownerLastName1Complete,
        setTitle:setTitle,
        title:title,
        titleComplete:titleComplete,
        setPhone:setPhone,
        phone:phone,
        phoneComplete:phoneComplete,
        setExtension:setExtension,
        extension:extension,
        setOwnerStreet:setOwnerStreet,
        ownerStreet:ownerStreet,
        ownerStreetComplete,ownerStreetComplete,
        setOwnerStreet2:setOwnerStreet2,
        ownerStreet2:ownerStreet2,
        setOwnerCity:setOwnerCity,
        ownerCity:ownerCity,
        ownerCityComplete:ownerCityComplete,
        setOwnerState:setOwnerState,
        ownerState:ownerState,
        ownerStateComplete:ownerStateComplete,
        setOwnerZip:setOwnerZip,
        ownerZip:ownerZip,
        ownerZipComplete:ownerZipComplete,
        setOwnerCountry:setOwnerCountry,
        ownerCountry:ownerCountry,
        setEmailAddress:setEmailAddress,
        emailAddress:emailAddress,
        emailAddressComplete:emailAddressComplete,
        setSecondaryOwner: setSecondaryOwner,
        secondaryOwner: secondaryOwner,
        setFirstName2:setFirstName2,
        firstName2:firstName2,
        lastName2:lastName2,
        setLastName2:setLastName2,
        lastName2Complete:lastName2,
        ownerFirstName2Complete:ownerFirstName2Complete,
        ownerLastName2Complete:ownerLastName2Complete,
        setTitle2:setTitle2,
        title2:title2,
        title2Complete:title2Complete,
        setPhone2:setPhone2,
        phone2:phone2,
        phone2Complete:phone2Complete,
        setExtension2:setExtension2,
        extension2:extension2,
        setOwner2Street:setOwner2Street,
        owner2Street:owner2Street,
        owner2StreetComplete,owner2StreetComplete,
        setOwner2Street2:setOwner2Street2,
        owner2Street2:owner2Street2,
        setOwner2City:setOwner2City,
        owner2City:owner2City,
        owner2CityComplete:owner2CityComplete,
        setOwner2State:setOwner2State,
        owner2State:owner2State,
        owner2StateComplete:owner2StateComplete,
        setOwner2Zip:setOwner2Zip,
        owner2Zip:owner2Zip,
        owner2ZipComplete:owner2ZipComplete,
        setOwner2Country:setOwner2Country,
        owner2Country:owner2Country,
        setEmailAddress2:setEmailAddress2,
        emailAddress2:emailAddress2,
        emailAddress2Complete:emailAddress2Complete,
    };

    const CreditCardInformationProps = {
        setNameOnCard:setNameOnCard,
        nameOnCard:nameOnCard,
        nameOnCardComplete:nameOnCardComplete,
        setCardNumber:setCardNumber,
        cardNumber:cardNumber,
        cardNumberComplete:cardNumberComplete,
        setExpDate:setExpDate,
        expDate:expDate,
        expDateComplete:expDateComplete,
        setCvv:setCvv,
        cvv:cvv,
        cvvComplete:cvvComplete,
        setCardZip:setCardZip,
        cardZip:cardZip,
        cardZipComplete:cardZipComplete,
    };

    const achProps = {
        achActive:achActive,
        setBankName:setBankName,
        bankName:bankName,
        bankNameComplete:bankNameComplete,
        setBankContactFirstName:setBankContactFirstName,
        bankContactFirstName:bankContactFirstName,
        setBankContactLastName:setBankContactLastName,
        bankContactLastName:bankContactLastName,
        bankContactFirstNameComplete:bankContactFirstNameComplete,
        bankContactLastNameComplete:bankContactLastNameComplete,
        setBankContactTitle:setBankContactTitle,
        bankContactTitle:bankContactTitle,
        bankContactTitleComplete:bankContactTitleComplete,
        setBankStreet:setBankStreet,
        bankStreet:bankStreet,
        setBankStreet2:setBankStreet2,
        bankStreet2:bankStreet2,
        bankStreetComplete:bankStreetComplete,
        setBankCity:setBankCity,
        bankCity:bankCity,
        bankCityComplete:bankCityComplete,
        setBankState:setBankState,
        bankState:bankState,
        bankStateComplete:bankStateComplete,
        setBankZip:setBankZip,
        bankZip:bankZip,
        bankZipComplete:bankZipComplete,
        setBankCountry:setBankCountry,
        bankCountry:bankCountry,
        bankCountryComplete:bankCountryComplete,
        setBankTelephone:setBankTelephone,
        bankTelephone:bankTelephone,
        bankTelephoneComplete:bankTelephoneComplete,
        setBankExtension:setBankExtension,
        bankExtension:bankExtension,
        setBankContactEmail:setBankContactEmail,
        bankContactEmail:bankContactEmail,
        bankContactEmailComplete:bankContactEmailComplete,
        setBankAccountName:setBankAccountName,
        bankAccountName:bankAccountName,
        bankAccountNameComplete:bankAccountNameComplete,
        setBankAccountNumber:setBankAccountNumber,
        bankAccountNumber:bankAccountNumber,
        bankAccountNumberComplete:bankAccountNumberComplete,
        setBankRoutingNumber:setBankRoutingNumber,
        bankRoutingNumber:bankRoutingNumber,
        bankRoutingNumberComplete:bankRoutingNumberComplete,
        setBankSwiftCode:setBankSwiftCode,
        bankSwiftCode:bankSwiftCode,
        bankSwiftCodeComplete:bankSwiftCodeComplete,
        setBankAccountSelection:setBankAccountSelection,
        bankAccountSelection:bankAccountSelection,
        bankAccountSelectionComplete:bankAccountSelectionComplete,
    };

    const TradeReferencesInformationProps = {
        setTradeReferencesFile:setTradeReferencesFile,
        setCompanyName:setCompanyName,
        companyName:companyName,
        companyNameComplete:companyNameComplete,
        setContactFirstName:setContactFirstName,
        contactFirstName:contactFirstName,
        setContactLastName:setContactLastName,
        contactLastName:contactLastName,
        contactTradeFirstNameComplete:contactTradeFirstNameComplete,
        contactTradeLastNameComplete:contactTradeLastNameComplete,
        setTradeTitle:setTradeTitle,
        tradeTitle:tradeTitle,
        tradeTitleComplete:tradeTitleComplete,
        setTradeEmail:setTradeEmail,
        tradeEmail:tradeEmail,
        tradeEmailComplete:tradeEmailComplete,
        setTradePhone:setTradePhone,
        tradePhone:tradePhone,
        tradePhoneComplete:tradePhoneComplete,
        setTradeExtension:setTradeExtension,
        tradeExtension:tradeExtension,
        setTradeStreet:setTradeStreet,
        tradeStreet:tradeStreet,
        setTradeStreet2:setTradeStreet2,
        tradeStreet2:tradeStreet2,
        tradeStreetComplete:tradeStreetComplete,
        setTradeCity:setTradeCity,
        tradeCity:tradeCity,
        tradeCityComplete:tradeCityComplete,
        setTradeState:setTradeState,
        tradeState:tradeState,
        tradeStateComplete:tradeStateComplete,
        setTradeZip:setTradeZip,
        tradeZip:tradeZip,
        tradeZipComplete:tradeZipComplete,
        setTradeCountry:setTradeCountry,
        tradeCountry:tradeCountry,
        tradeCountryComplete:tradeCountryComplete,
        setSecondaryReference:setSecondaryReference,
        secondaryReference:secondaryReference,
        setCompanyName2:setCompanyName2,
        companyName2:companyName2,
        companyName2Complete:companyName2Complete,
        setContactFirstName2:setContactFirstName2,
        contactFirstName2:contactFirstName2,
        setContactLastName2:setContactLastName2,
        contactLastName2:contactLastName2,
        contactTradeFirstName2Complete:contactTradeFirstName2Complete,
        contactTradeLastName2Complete:contactTradeLastName2Complete,
        setTradeTitle2:setTradeTitle2,
        tradeTitle2:tradeTitle2,
        tradeTitle2Complete:tradeTitle2Complete,
        setTradeEmail2:setTradeEmail2,
        tradeEmail2:tradeEmail2,
        tradeEmail2Complete:tradeEmail2Complete,
        setTradePhone2:setTradePhone2,
        tradePhone2:tradePhone2,
        tradePhone2Complete:tradePhone2Complete,
        setTradeExtension2:setTradeExtension2,
        tradeExtension2:tradeExtension2,
        setTrade2Street:setTrade2Street,
        trade2Street:trade2Street,
        setTrade2Street2:setTrade2Street2,
        trade2Street2:trade2Street2,
        trade2StreetComplete:trade2StreetComplete,
        setTrade2City:setTrade2City,
        trade2City:trade2City,
        trade2CityComplete:trade2CityComplete,
        setTrade2State:setTrade2State,
        trade2State:trade2State,
        trade2StateComplete:trade2StateComplete,
        setTrade2Zip:setTrade2Zip,
        trade2Zip:trade2Zip,
        trade2ZipComplete:trade2ZipComplete,
        setTrade2Country:setTrade2Country,
        trade2Country:trade2Country,
        trade2CountryComplete:trade2CountryComplete,
        setThirdReference:setThirdReference,
        thirdReference:thirdReference,
        setCompanyName3:setCompanyName3,
        companyName3:companyName3,
        companyName3Complete:companyName3Complete,
        setContactFirstName3:setContactFirstName3,
        contactFirstName3:contactFirstName2,
        setContactLastName3:setContactLastName3,
        contactLastName3:contactLastName3,
        contactTradeFirstName3Complete:contactTradeFirstName3Complete,
        contactTradeLastName3Complete:contactTradeLastName3Complete,
        setTradeTitle3:setTradeTitle3,
        tradeTitle3:tradeTitle3,
        tradeTitle3Complete:tradeTitle3Complete,
        setTradeEmail3:setTradeEmail3,
        tradeEmail3:tradeEmail3,
        tradeEmail3Complete:tradeEmail3Complete,
        setTradePhone3:setTradePhone3,
        tradePhone3:tradePhone3,
        tradePhone3Complete:tradePhone3Complete,
        setTradeExtension3:setTradeExtension3,
        tradeExtension3:tradeExtension3,
        setTrade3Street:setTrade3Street,
        trade3Street:trade3Street,
        setTrade3Street2:setTrade3Street2,
        trade3Street2:trade3Street2,
        trade3StreetComplete:trade3StreetComplete,
        setTrade3City:setTrade3City,
        trade3City:trade3City,
        trade3CityComplete:trade3CityComplete,
        setTrade3State:setTrade3State,
        trade3State:trade3State,
        trade3StateComplete:trade3StateComplete,
        setTrade3Zip:setTrade3Zip,
        trade3Zip:trade3Zip,
        trade3ZipComplete:trade3ZipComplete,
        setTrade3Country:setTrade3Country,
        trade3Country:trade3Country,
        trade3CountryComplete:trade3CountryComplete
    };

    const ConditionsAndAuthorizationsProps = {
        conditionsActive:conditionsActive,
        setConditionsComplete:setConditionsComplete,
        conditionsComplete:conditionsComplete,
        setNameSign:setNameSign,
        nameSign:nameSign,
        nameSignComplete:nameSignComplete,
        setTitleSign:setTitleSign,
        titleSign:titleSign,
        titleSignComplete:titleSignComplete,
        ///signature:signature,
        setSignature:setSignature,
        signatureComplete:signatureComplete,
        setDate:setDate,
        date:date,
        dateComplete:dateComplete,
        setSecondarySignature:setSecondarySignature,
        secondarySignature:secondarySignature,
        setNameSign2:setNameSign2,
        nameSign2:nameSign2,
        nameSign2Complete:nameSign2Complete,
        setTitleSign2:setTitleSign2,
        titleSign2:titleSign2,
        titleSign2Complete:titleSign2Complete,
        setSignature2:setSignature2,
        //signature2:signature2,
        signature2Complete:signature2Complete,
        setDate2:setDate2,
        date2:date2,
        date2Complete:date2Complete

        
    };    

    // - - - - SUBMIT - - - - - -
    // CREATE CUSTOMER OBJECT TO SEND TO SERVER
    const createCustomerRequestObject = () => {
        let notes = '';

        if(w9Error) notes = `${notes} - W9 Failed to Upload`;
        if(taxCertError) notes = `${notes} - Tax Exempt Certification Failed to Upload`;
        if(intWireError) notes = `${notes} - Int. Wire Instructions Failed to Upload`;
        if(voidedCheckError) notes = `${notes} - Voided Check Failed to Upload`;
        if(creditReferenceSheetError) notes = `${notes} - Credit Reference Sheet Failed to Upload`;

        const customerObject = {    
            fedEinSSn:fedEinSSn,
            dunsNo:dunsNo,
            website:website,
            legalName:legalName,
            tradeNameDBA:tradeNameDBA,
            businessType: businessTypeSelection,
            class: customerClassSelection,
            poRequired: poRequired,
            currency: invoiceCurrency,
            taxExempt: taxExemptCert,
            address : {
                street:street,
                street2:street2,
                city:city,
                state:state,
                zip:zip,
                country:country,
            },
            shippingAddress : {
                street:shippingStreet,
                street2:shippingStreet2,
                city:shippingCity,
                state:shippingState,
                zip:shippingZip,
                country:shippingCountry,
            },
            primaryContact : {
                firstName:primaryContactFirstName,
                lastName:primaryContactLastName,
                number:primaryContactNumber,
                extension:primaryExtension,
                title:primaryTitle,
                email:primaryContactEmail,
            },
            apContact : {
                firstName:contactFirstNameAP,
                lastName:contactLastNameAP,
                number:phoneAP,
                extension:extensionAP,
                title:titleAP,
                email:contactEmailAP, 
            },
            paymentMethod:paymentMethod,
            incState:stateOfInc,
            bankAccount : {
                name:bankName,
                accountName:bankAccountName,
                accountNumber:bankAccountNumber,
                routingNumber: bankRoutingNumber,
                swiftCode:bankSwiftCode,
                accountType:bankAccountSelection,
                address: {
                    street:bankStreet,
                    street2:bankStreet2,
                    city:bankCity,
                    state:bankState,
                    zip:bankZip,
                    country:bankCountry
                },
                contact: {
                    firstName:bankContactFirstName,
                    lastName:bankContactLastName,
                    number:bankTelephone,
                    extension:bankExtension,
                    title:bankContactTitle,
                    email:bankContactEmail,
                }
            },
            authorizedOfficers : [
                { 
                    firstName:firstName1,
                    lastName:lastName1,
                    number:phone,
                    extension:extension,
                    title:title,
                    email:emailAddress,
                    address: {
                        street:ownerStreet,
                        street2:ownerStreet2,
                        city:ownerCity,
                        state:ownerState,
                        zip:ownerZip,
                        country:ownerCountry
                    
                    },
                },
                {
                    firstName:firstName2,
                    lastName:lastName2,
                    number:phone2,
                    extension:extension2,
                    title:title2,
                    email:emailAddress2,
                    address: {
                        street:owner2Street,
                        street2:owner2Street2,
                        city:owner2City,
                        state:ownerState,
                        zip:owner2Zip,
                        country:owner2Country
                    },
                },
            ],
            creditCard : {
                name:nameOnCard,
                number:cardNumber,
                expiration:expDate,
                billingZip:cardZip,
                securityCode:cvv,
            },
            tradeReferences : [
                {
                    firstName:contactFirstName,
                    lastName:contactLastName,
                    number:tradePhone,
                    extension:tradeExtension,
                    title:tradeTitle,
                    company:companyName,
                    email:tradeEmail,
                    address: {
                        street:tradeStreet,
                        street2:tradeStreet2,
                        city:tradeCity,
                        state:tradeState,
                        zip:tradeZip,
                        country:tradeCountry,

                    }
                },
                {
                    firstName:contactFirstName2,
                    lastName:contactLastName2,
                    number:tradePhone2,
                    extension:tradeExtension2,
                    title:tradeTitle2,
                    company:companyName2,
                    email:tradeEmail2,
                    address: {
                        street:trade2Street,
                        street2:trade2Street2,
                        city:trade2City,
                        state:trade2State,
                        zip:trade2Zip,
                        country:trade2Country,

                    }
                },
                {
                    firstName:contactFirstName3,
                    lastName:contactLastName3,
                    number:tradePhone3,
                    extension:tradeExtension3,
                    title:tradeTitle3,
                    company:companyName3,
                    email:tradeEmail3,
                    address: {
                        street:trade3Street,
                        street2:trade3Street2,
                        city:trade3City,
                        state:trade3State,
                        zip:trade3Zip,
                        country:trade3Country,
                    }
                },
            ],
            signer1Name:nameSign,
            signer1Title:titleSign,
            signature:signature,
            signer2Name:nameSign2,
            signer2Title:titleSign2,
            signature2:signature2,
            w9File:w9Id,
            voidedCheckFile:voidedCheckFileId,
            internationalWireFile:intWireId,
            taxExemptionFile: taxCertId,
            creditReferencesSheetFile: creditReferenceSheetId,
            tradeReferencesSheetFile: tradeReferencesFileId,
            notificationEmail : `${notificationEmail ? notificationEmail : null}`,
            notes: notes
            
        };

        return customerObject;
    };

    const createCustomerUpdateRequestObject = () => {
        let customerObject = createCustomerRequestObject();

        customerObject.rejectionId = rejectionRecord.id;

        customerObject.id = rejectionRecord.customerProfile.id;
        customerObject.address.id = rejectionRecord.customerProfile.address.id
        customerObject.shippingAddress.id = rejectionRecord.customerProfile.shippingAddress.id;
        // Contacts
        customerObject.primaryContact.id = rejectionRecord.customerProfile.primaryContact.id;
        customerObject.apContact.id = rejectionRecord.customerProfile.apContact.id;

        // Bank Account Ids
        if(rejectionRecord.customerProfile.bankAccount){
            customerObject.bankAccount.id = rejectionRecord.customerProfile.bankAccount.id;
            if(rejectionRecord.customerProfile.bankAccount.address){
                customerObject.bankAccount.address.id = rejectionRecord.customerProfile.bankAccount.address.id;
            };
            if(rejectionRecord.customerProfile.bankAccount.contact){
                customerObject.bankAccount.contact.id = rejectionRecord.customerProfile.bankAccount.contact.id;
            };
        };

        // Authorized Officers Ids
        if(rejectionRecord.customerProfile.authorizedOfficers){
            if(rejectionRecord.customerProfile.authorizedOfficers[0]){
                customerObject.authorizedOfficers[0].id = rejectionRecord.customerProfile.authorizedOfficers[0].id
                if(rejectionRecord.customerProfile.authorizedOfficers[0].address){
                    customerObject.authorizedOfficers[0].address.id = rejectionRecord.customerProfile.authorizedOfficers[0].address.id
                }
            }
            if(rejectionRecord.customerProfile.authorizedOfficers[1]){
                customerObject.authorizedOfficers[1].id = rejectionRecord.customerProfile.authorizedOfficers[1].id
                if(rejectionRecord.customerProfile.authorizedOfficers[1].address){
                    customerObject.authorizedOfficers[1].address.id = rejectionRecord.customerProfile.authorizedOfficers[1].address.id
                }
            }
        }

        // Trade References Ids
        if(rejectionRecord.customerProfile.tradeReferences){
            if(rejectionRecord.customerProfile.tradeReferences[0]){
                customerObject.tradeReferences[0].id = rejectionRecord.customerProfile.tradeReferences[0].id
                if(rejectionRecord.customerProfile.tradeReferences[0].address){
                    customerObject.tradeReferences[0].address.id = rejectionRecord.customerProfile.tradeReferences[0].address.id
                }
            }
            if(rejectionRecord.customerProfile.tradeReferences[1]){
                customerObject.tradeReferences[1].id = rejectionRecord.customerProfile.tradeReferences[1].id
                if(rejectionRecord.customerProfile.tradeReferences[1].address){
                    customerObject.tradeReferences[1].address.id = rejectionRecord.customerProfile.tradeReferences[1].address.id
                }
            }
            if(rejectionRecord.customerProfile.tradeReferences[2]){
                customerObject.tradeReferences[2].id = rejectionRecord.customerProfile.tradeReferences[2].id
                if(rejectionRecord.customerProfile.tradeReferences[2].address){
                    customerObject.tradeReferences[2].address.id = rejectionRecord.customerProfile.tradeReferences[2].address.id
                }
            }
        };      
        
        // Files if not uploaded
        if(rejectionRecord.customerProfile.w9 && !w9) customerObject.w9File = rejectionRecord.customerProfile.w9;
        if(rejectionRecord.customerProfile.taxExemption && !taxCert) customerObject.taxExemptionFile = rejectionRecord.customerProfile.taxExemption;
        if(rejectionRecord.customerProfile.internationalWire && !intWire) customerObject.internationalWireFile = rejectionRecord.customerProfile.internationalWire;
        if(rejectionRecord.customerProfile.voidedCheck && !voidedCheckFile) customerObject.voidedCheckFile = rejectionRecord.customerProfile.voidedCheck;
        if(rejectionRecord.customerProfile.creditSheet && !creditReferenceSheet) customerObject.creditReferencesSheetFile = rejectionRecord.customerProfile.creditSheet;
        if(rejectionRecord.customerProfile.tradeSheet && !tradeReferencesFile) customerObject.tradeReferencesSheetFile = rejectionRecord.customerProfile.tradeSheet;

        return customerObject;
    };

    // WAITS FOR ALL FILES TO BE UPLOADED AND THEN CALLS TO SEND OBJECT TO SERVER
    useEffect(() => {
        let complete = true;

        if(!checkFormFields()) complete = false;
        if(w9 && !w9Id) if(!w9Error) complete = false;
        if(taxCert && !taxCertId) if(!taxCertError) complete = false;
        if(intWire && !intWireId) if(!intWireError) complete = false;
        if(voidedCheckFile && !voidedCheckFileId) if(!voidedCheckError) complete = false;
        if(creditReferenceSheet && !creditReferenceSheetId) if(!creditReferenceSheetError) complete = false;
        if(tradeReferencesFile && !tradeReferencesFileId) if(!tradeReferencesFileError) complete = false;

        if(complete && !rejectionRecord) submitCustomerRequest(createCustomerRequestObject(),setFormSubmissionValid);
        if(complete && rejectionRecord) submitCustomerUpdateRequest(createCustomerUpdateRequestObject(),setFormSubmissionValid);
    },[w9Id,w9Error,taxCertId,taxCertError,intWireId,intWireError,voidedCheckFileId,voidedCheckError,creditReferenceSheetId,creditReferenceSheetError,tradeReferencesFileId,tradeReferencesFileError]);

    // INITIAL CALL TO SUBMIT
    const submitForm = () => {
        setSubmitting(true);
        let waitingOnFiles = false;

        //Submit w9
        if(w9){
            sendW9(w9[0],`${legalName}-W9-${getDate()}.pdf`,setW9Id,setW9Error);
            waitingOnFiles = true;
        };

        if(tradeReferencesFile){
            sendTradeReferenceSheet(tradeReferencesFile[0],`${legalName}-Trade References-${getDate()}.pdf`,setTradeReferencesFileId,setTradeReferencesFileError);
            waitingOnFiles = true;
        }
        
        //Submit Voided Check (if Required)
        if(voidedCheckFile){
            sendVoidedCheck(voidedCheckFile[0],`${legalName}-Void Check-${getDate()}.pdf`,setVoidedCheckFileId,setVoidedCheckError);
            waitingOnFiles = true;
        };

        //Submit Internation Wire (if Required)
        if(intWire){
            sendInternationalWire(intWire[0],`${legalName}-Int Wire-${getDate()}.pdf`,setIntWireId,setIntWireError);
            waitingOnFiles = true;
        };

        //Submit Tax Exemption (if Required)
        if(taxCert){
            sendTaxCert(taxCert[0],`${legalName}-Tax Cert-${getDate()}.pdf`,setTaxCertId,setTaxCertError);
            waitingOnFiles = true;
        };

        //Submit Credit Reference Sheet (if Required)
        if(creditReferenceSheet){
            sendCreditReferenceSheet(creditReferenceSheet[0],`${legalName}-CreditRef-${getDate()}.pdf`,setCreditReferenceSheetId,setCreditReferenceSheetError);
            waitingOnFiles = true;
        };
        
        if(!waitingOnFiles && !rejectionRecord) submitCustomerRequest(createCustomerRequestObject(),setFormSubmissionValid);
        if(!waitingOnFiles && rejectionRecord) submitCustomerUpdateRequest(createCustomerUpdateRequestObject(),setFormSubmissionValid);
    };

    // - - - - - RENDER - - - - -
    return(
        <div className='External-Form-Window'>
            {   !submitting &&
                <div className='External-Form-Page'>
                    <FormHeader formEmail={formEmail}/>
                    {   rejectionRecord &&
                        <RejectionHeader {...rejectionProps}/>
                    }
                    
                    <CustomerInformation {...customerInformationProps} />

                    {   customerInformationComplete &&
                        <>
                            <PrimaryContactAndAPInformation {...primaryAndAPProps}/>
                            
                            {   primaryAndAPComplete &&
                                <>
                                <OwnersOrOfficersInformation {...OwnersOrOfficersInformationProps} />  

                                {   ownersOrOfficersInformationComplete &&
                                    <>
                                        <TradeReferencesInformation {...TradeReferencesInformationProps} />

                                        {   tradeReferencesInformationComplete &&
                                            <>
                                                {   creditCardShown &&
                                                    <CreditCardInformation {...CreditCardInformationProps} />
                                                }

                                                {   paymentInformationComplete &&
                                                    <>
                                                        {   filesRequired &&
                                                            <RequiredFilesSection filesActive={filesActive} 
                                                                w9Shown={w9Shown} w9={w9} setW9={setW9} w9Active={w9Active} 
                                                                creditReferenceSheetShown={creditReferenceSheetShown} creditReferenceSheet={creditReferenceSheet} setCreditReferenceSheet={setCreditReferenceSheet} creditReferenceSheetActive={creditReferenceSheetActive} 
                                                                voidedCheckShown={voidedCheckShown} voidedCheckFile={voidedCheckFile} setVoidedCheckFile={setVoidedCheckFile} voidedCheckActive={voidedCheckActive}
                                                                intWireShown={intWireShown} intWire={intWire} setIntWire={setIntWire} intWireActive={intWireActive}
                                                                taxCertShown={taxCertShown} taxCert={taxCert} setTaxCert={setTaxCert} taxCertActive={taxCertActive}
                                                                rejectionRecord={rejectionRecord}
                                                            />
                                                        }

                                                        {   filesCompleted &&
                                                            <ConditionsAndAuthorizations {...ConditionsAndAuthorizationsProps} />
                                                        }

                                                    </>
                                                }
                                            </>
                                        }
                                    </>
                                }
                                </>
                            }
                        </>
                    }


                    {   formComplete && !rejectionRecord &&
                        <button onClick={() => submitForm()} className='External-Customer-Submit External-Customer-Button'>Submit Form</button>
                    }

                    {   formComplete && rejectionRecord &&
                        <>
                        <button onClick={() => submitForm()} className='External-Customer-Submit External-Customer-Button'>Update Form</button>
                        </>
                    }

                    <img src={'https://www.positivessl.com/images/seals/positivessl_trust_seal_md_167x42.png'} className='External-Vendor-SSL'/>

                </div>
            }
            {   submitting && 
                <div className='External-Form-Window'>
                    <div className='External-Form-Page'>
                        <FormHeader formEmail={formEmail}/>
                        <FormSubmissionWindow 
                            taxCert={taxCert} taxCertId={taxCertId} taxCertError={taxCertError}
                            voidedCheckFile={voidedCheckFile} voidedCheckFileId={voidedCheckFileId} voidedCheckError={voidedCheckError}
                            w9={w9} w9Id={w9Id} w9Error={w9Error}
                            intWire={intWire} intWireId={intWireId} intWireError={intWireError}
                            creditReferenceSheet={creditReferenceSheet} creditReferenceSheetId={creditReferenceSheetId} creditReferenceSheetError={creditReferenceSheetError}
                            tradeReferencesFile={tradeReferencesFile} tradeReferencesFileId={tradeReferencesFileId} tradeReferencesFileError={tradeReferencesFileError}
                            formSubmissionValid={formSubmissionValid}
                        />
                    </div>
                </div>
            }

        </div>
    );
};

export default NewCustomer;